export default {
    service_price_modifiers: "Price Modifiers",
    service_cost_modifiers: "Cost Modifiers",
    add_service_modifier: "Add Modifier",
    modifier_name: "Modifier Name",
    modifier_amount: "Amount",
    modifier_type: "Type",
    modifier_addition: "Addition (+)",
    modifier_deduction: "Deduction (-)",
    no_modifiers_configured: "No modifiers configured for this service",
    no_cost_modifiers_configured: "No cost modifiers configured for this service",
    applied_modifiers: "Modifiers",
    applied_modifiers_desc: "Toggle modifiers to adjust the price",
    modifiers_count: "modifiers",
    manage_price_modifiers: "Manage Price Modifiers",
    manage_cost_modifiers: "Manage Cost Modifiers",
    delete_modifier_confirm: "Delete this modifier?",
    send_assignment_email: "Send assignments by email",
    send_email_to_business: "Send email to business",
    assigned_paxs_summary: "You have {{count}} paxs assigned for {{date}}",
    preview_message: "Message preview",
    active_reservations_in_date: "Active reservations in {{date}}",
    menu_permissions: "Menu Permissions",
    create_action_permissions: "Create Action Permissions",
    create_permissions: "Creation Permissions",
    allowed_views: "Allowed Views",
    allowed_create_actions: "Allowed Creation Actions",
    allowed_businesses: "Allowed Businesses",
    no_businesses_allowed: "No businesses allowed",
    full_access_desc: "Full access to all sections, actions, and businesses without restrictions.",
    reservation_business_access: "Reservation Business Access",
    reservation_business_access_desc: "Choose whether this user can create reservations for any business or only specific selected businesses.",
    reservation_edit_access: "Reservation Edit Access",
    edit_prices_and_costs_manually: "Edit Prices and Costs Manually",
    edit_prices_and_costs_manually_desc: "Allows modifying and resetting reservation prices and costs manually.",
    no_manual_price_cost_access: "No manual price and cost editing",
    only_created_reservations: "Only Created by User",
    edition_group_reservations: "By Edition Group",
    edition_group_reservations_desc: "User can edit reservations created by members of the same group",
    edition_group: "Edition Group",
    edition_groups: "Edition Groups",
    edition_group_desc: "Users in the same edition group will be able to edit reservations created by each other.",
    create_edition_group: "Create Group",
    edition_group_placeholder: "Group name (e.g. Sales, Reception)...",
    existing_edition_groups: "Existing groups",
    no_edition_group_selected: "No group assigned. The user will only be able to edit their own reservations.",
    users_in_group: "Group members",
    no_other_users_in_group: "No other users in this group yet.",
    no_edition_groups_created: "No groups created yet. Type a name to create the first one.",
    current_edition_group: "Currently assigned group",
    clear_edition_group: "Remove group",
    selected_businesses: "Selected Businesses Only",
    select_allowed_businesses: "Select Allowed Businesses",
    no_businesses_selected: "No businesses selected. User will not be able to create reservations for any business until businesses are added.",
    unauthorized_business: "You are not authorized to create reservations for this business",
    filter_both: "Both",
    filter_departures: "Departures",
    filter_arrivals: "Arrivals",
    permissions: "Permissions",
    search_users: "Search users...",
    full_access: "Full Access",
    custom_access: "Custom Access",
    never: "Never",
    add_another_field: "Add another {{key}}",
    duplicate_client_warning: "Duplicate Client Warning",
    duplicate_client_name_desc: "There are other clients with the name '{{name}}'. Please check if this client is correct.",
    duplicated_name: "This name is already registered.",
    create_another: "Create another",
    create_child_reservation: "Create Child Reservation",
    derived_from_reservation: "Derived from Reservation",
    parent_reservation_bookings: "Original Reservation Bookings",
    original_reservation: "Original reservation",
    child_reservations: "Derived reservations",
    reservation_type: "Reservation type",
    main_reservations_only: "Only main (without parent)",
    child_reservations_only: "Only derived (with parent)",
    contact_details: "Contact Details",
    account_overview: "Account Overview",
    banking_info: "Banking Information",
    quick_actions: "Quick Actions",
    tax_information: "Tax Information",
    business_category: "Business Category",
    account_status: "Account Status",
    cbu_alias: "CBU / Alias",
    no_bookings_in_parent: "No bookings in original reservation",
    select_client_for_child_reservation: "Select Client for Child Reservation",
    select_client_to_assign_to_new_reservation: "Select the client to assign to the new child reservation.",
    simulating_prices_for_selected_business: "Simulating custom prices for selected business",
    select_business_to_view_custom_tariffs: "Select a business to apply custom tariff discounts",
    budget: "Budget",
    pinned_services: "Pinned Services",
    no_pinned_services: "No pinned services",
    click_to_pin: "Click on any service card to pin it to this simulator panel.",
    copy_summary: "Copy Summary",
    summary_copied: "Summary copied to clipboard!",
    settings_saved_success: "Settings saved successfully",
    enable_public_exchange_rates_title: "Enable Currency Conversion on Public Website",
    enable_public_exchange_rates_desc: "Allow customers on the public website to convert prices to other currencies using these exchange rates. If disabled, only original prices are shown.",
    daily_evolution: "Daily Evolution",
    paxs_evolution: "Passengers Evolution",
    services_evolution: "Services Evolution",
    money_evolution: "Revenue & Costs Evolution",
    same_origin_destination_warning: "The origin and destination cannot be the same.",
    complete_business_data: "Complete Business Data",
    legend: "Legend",
    booking_pax_count_mismatch: "The booking total ({{categorySum}}) does not match the assigned passengers ({{personsSum}})",
    complete_business_data_description: "Please fill in the required tax and location information for this business.",
    passenger_current_reservation: "Passenger's Current Reservation",
    group_all_bookings: 'Group all bookings',
    loading_reservation: "Loading current reservation...",
    accept: 'Accept',
    slots: 'Slots',
    occupied: 'occupied',
    default_inventory_slots: 'Default Inventory Slots',
    default_inventory_slots_desc: 'Default number of slots occupied by this service when booked',
    access: 'Access',
    buy: 'Buy',
    buy_services: 'Buy Services',
    select_vendor: 'Select Vendor',
    select_client_business: 'Select Client Business',
    confirm_purchase: 'Confirm Purchase',
    purchase_successful: 'Purchase Successful',
    error_during_purchase: 'Error occurred during purchase',
    no_services_available: 'No services available from this vendor',
    back: 'Back',
    next: 'Next',
    select_vendor_placeholder: 'Choose partner to buy from',
    select_client_placeholder: 'Select your buying business',
    search_services: 'Search services by name, category, city...',
    estimated_price: 'Estimated Price',
    no_matching_services: 'No services match your search.',
    confirm_review_details: 'Please review the details of your reservation request below.',
    no_pricing_available: 'Pricing details not resolved.',
    error: 'Error',
    invalid_dates: 'Please enter valid dates',
    no_additional_attributes: 'No additional fields required.',
    no_paxs_selected: 'No passengers selected',
    no_services_selected: 'No services selected',
    passenger: 'Passenger',
    please_enter_pax_sizes: 'Please enter a group size for at least one passenger',
    please_select_all_fields: 'Please select all fields',
    reservation_created_successfully: 'Reservation created successfully',
    step_confirm_price: 'Confirm',
    step_from_who_whom: 'From / Whom',
    step_paxs: 'Passengers',
    step_select_services: 'Services',
    step_title: 'Step {{step}}',
    group_size: 'Group Size',
    enter_start_day: 'Enter start day',
    account_settings: 'Account Settings',
    account_statement: 'Account Statement',
    balance_as_client_disclaimer: 'This balance does NOT include reservations as provider.',
    check_full_balance: 'For full balance details, check the Balance section',
    actions: 'Actions',
    actions_here_cannot_be_undone: 'Changes made here cannot be undone',
    active: 'Active',
    active_costs: 'Active Costs',
    active_during_date: 'Active during date',
    active_filters: 'Active Filters',
    advanced_filters: 'Advanced Filters',
    active_prices: 'Active Prices',
    active_services: 'Active Services',
    active_stock_periods: 'Active Stock Periods',
    active_template: 'Active Template',
    active_today: 'Active today',
    activities: 'Activities',
    activities_list: {
        generic_action: 'Action',
        new_service_cost: 'New cost',
        new_service_price: 'New price',
        reservation_person_added: 'Person added to reservation',
        reservation_person_removed: 'Person removed from reservation',
        service_cost_created: 'Service cost created',
        service_cost_updated: 'Updated service cost',
        service_price_created: 'Service price created',
        service_price_updated: 'Updated service price'
    },
    activity: 'Activity',
    activity_plural: 'Activities',
    actual_payment: 'Actual Payment',
    add: 'Add',
    add_attribute: 'Add Attribute',
    add_booking: 'Add Service Reservation',
    add_bookings: 'Add Bookings',
    add_business: 'Add Company',
    add_child_cost: 'Add Lower Cost',
    add_child_item: 'Add Item Below',
    add_child_price: 'Add Lower Price',
    add_child_service: 'Add service to package',
    add_cost: 'Add Cost',
    add_discount: 'Add Discount',
    add_discount_category: 'Add Discount Category',
    add_exchange_rate: 'Add Exchange Rate',
    add_foreigner_cost: 'Add Foreign Cost',
    add_foreigner_price: 'Add Foreign Price',
    add_infant_cost: 'Add Child Cost',
    add_infant_price: 'Add Child Price',
    add_money_in_out: 'Entry/Exit',
    add_more_items: 'Add more items',
    add_new_attribute: 'Add New Attribute',
    add_new_my_business: 'Add New Own Company',
    add_new_payment: 'Add New Payment',
    add_new_provider: 'Add Supplier',
    add_pax: 'Add Pax',
    add_pax_to_housing: 'Add Pax to Housing',
    add_pax_to_reservation: 'Add Pax to Reservation',
    add_pax_to_service: 'Add Pax to Service',
    add_pax_to_transfer: 'Add Pax to Transfer',
    add_payment: 'Add Payment',
    add_person: 'Add Person',
    add_person_to_housing: 'Add Person to Housing',
    add_person_to_reservation: 'Add Person to Reservation',
    add_person_to_transfer: 'Add Person to Transfer',
    add_persons_to_vehicle_booking: 'Add persons to vehicle booking',
    add_price: 'Add Price',
    add_prices: 'Add Prices',
    add_property: 'Add Property',
    add_provider: 'Add Supplier',
    add_provider_cost: 'Add Supplier Cost',
    add_provider_price: 'Add Supplier Price',
    add_providers: 'Add Suppliers',
    add_provier: 'Add Supplier',
    add_reservation: 'Add Reservation',
    add_reservation_payment: 'Add Reservation Payment',
    add_reservation_status: 'Add Reservation Status',
    add_reservations: 'Add Reservations',
    add_senior_cost: 'Add Retired Cost',
    add_senior_price: 'Add Retired Price',
    add_service: 'Add Service',
    add_service_directly: 'Add Service Directly',
    add_service_first_first: 'Add Services First',
    add_service_to_group: 'Add Service to Package',
    add_service_to_this_order: 'Add Selected Service to this Order',
    add_services: 'Add Services',
    add_services_to_group: 'Add Services to the Package',
    add_staff: 'Add Staff',
    add_status: 'Add Status',
    add_stock_period: 'Add Stock Period',
    add_tag: 'Add Category',
    add_template: 'Add Template',
    add_time_slot: 'Add Time Slot',
    add_to_reservation: 'Add to reservation',
    add_transaction: 'Add Transaction',
    add_user: 'Add User',
    add_vehicle: 'Add Vehicle',
    additional_details: 'Additional Details',
    additional_notes: 'Additional Notes',
    address: 'Address',
    address_and_phone: 'Address and Telephone',
    admin: 'Admin',
    adults: 'Adults',
    affect_reservations: 'Affect Reservations',
    after_tomorrow: 'The day after tomorrow',
    age: 'Age',
    agency: 'Agency',
    agenda: 'Agenda',
    agenda_orders: 'Order Agenda',
    agenda_description: 'Manage unpaid reservation payment dues and upcoming obligations',
    agenda_overdue_alert: 'overdue reservation payments requiring immediate attention',
    agenda_view_calendar: 'Calendar',
    agenda_view_list: 'List',
    agenda_view_timeline: 'Timeline',
    agenda_no_dues: 'No unpaid reservation dues found',
    agenda_total_owed: 'Total Owed',
    agenda_dues_count: 'Pending Dues',
    agenda_day_dues_title: 'Payment Dues for {{date}}',
    agenda_overdue_badge: 'Overdue',
    agenda_days_overdue: '{{count}}d overdue',
    agenda_due_in_days: 'Due in {{count}}d',
    agenda_due_today: 'Due today',
    agenda_view_reservation: 'View Reservation',
    agenda_copy_link: 'Copy Link',
    agenda_all_dues: 'All Dues',
    agenda_overdue_only: 'Overdue Only',
    agenda_upcoming_only: 'Upcoming Only',
    agenda_category_unpaid_reservations: 'Unpaid reservations with a due date',
    agenda_category_tickets: 'Pending tickets with a deadline',
    agenda_filter_all: 'All',
    agenda_filter_reservations: 'Reservations',
    agenda_filter_tickets: 'Tickets',
    agenda_sort_date: 'Date',
    agenda_sort_category: 'Category',
    agenda_sort_assignee: 'Assignee',
    agenda_group_overdue: 'Overdue',
    agenda_group_today: 'Due Today',
    agenda_group_upcoming: 'Upcoming',
    agenda_group_no_date: 'No Deadline',
    agenda_no_items: 'No agenda items found',
    agenda_reservation_label: 'Reservation',
    agenda_ticket_label: 'Ticket',
    agenda_day_items_title: 'Agenda for {{date}}',
    agenda_show_completed: 'Show completed',
    agenda_due_payment: 'Payment due',
    agenda_view_single_list: 'Single List',
    agenda_view_by_category: 'By Category',
    agenda_all_categories: 'All Categories',
    assignments: 'Assignments',
    reservation_assignments: 'Reservation Assignments',
    service_order_assignments: 'Service Order Assignments',
    no_reservation_assignments: 'No reservation assignments',
    no_service_order_assignments: 'No service order assignments',
    no_assignments_yet_desc: 'When other agencies book services from your businesses, they will show up here.',
    no_results_for_search: 'Try adjusting your search query',
    shared_booking: 'Shared booking',
    shared: 'Shared',
    no_provider: 'No provider',
    assigned_by: 'Assigned By',
    'ai-chat': 'AI Chat',
    'ai-chat-description': 'Chat with AI assistant',
    'ai-chat-placeholder': 'Type your message here...',
    'ai-chat-start': 'Start a conversation with the AI assistant',
    'ai-chat-thinking': 'AI is thinking...',
    ai_chat: 'AI Chat',
    ai_chat_placeholder: 'Write your message',
    ai_chat_thinking: 'thinking...',
    air: 'Aerial',
    all: 'All',
    all_businesses: 'All Companies',
    all_categories: 'All categories',
    all_dates: 'With and Without Date',
    all_days: 'every day',
    all_items: 'All Items',
    all_my_business: 'All my companies',
    all_paxs: 'All passengers',
    all_persons: 'All People',
    all_plural: 'all',
    all_providers: 'All Suppliers',
    all_rights_reserved: 'All rights reserved',
    all_service_bookings: 'All Service Reservations',
    all_services: 'All Services',
    all_types: 'All types',
    alls: 'all',
    almost_there: 'almost ready',
    also_update_linked_service: 'Also update mirror service',
    book_linked_service: 'Book mirror service: {{name}}',
    book_linked_service_question: 'Also book this mirror service?',
    normally_booked_together: 'Normally booked together',
    amenities: 'Amenities',
    amount: 'Amount',
    amount_paid_from: 'Paid for',
    amount_paid_to: 'Paid to',
    amount_to_pay: 'Amount to Pay',
    amounts_match: 'Amounts match',
    apartment: 'Apartment',
    api_logs: {
        business_created: 'New business',
        business_deleted: 'Delete business',
        business_updated: 'Update business',
        inventory_item_created: 'New inventory item',
        inventory_item_deleted: 'Delete inventory item',
        inventory_item_updated: 'Update inventory item',
        new_user_created: 'New user',
        person_created: 'new person',
        person_deleted: 'Delete person',
        person_updated: 'Update person',
        provider_created: 'New supplier',
        provider_deleted: 'Delete supplier',
        provider_updated: 'Update provider',
        reservation_created: 'New reservation',
        reservation_deleted: 'Delete reservation',
        reservation_person_added: 'Add person to reservation',
        reservation_person_removed: 'Remove person from reservation',
        reservation_updated: 'Update reservation',
        service_booking_created: 'New service booking',
        service_booking_deleted: 'Delete service booking',
        service_booking_updated: 'Update service booking',
        service_cost_created: 'New service cost',
        service_cost_deleted: 'Eliminate service cost',
        service_cost_updated: 'Update service cost',
        service_created: 'New service',
        service_deleted: 'Delete service',
        service_group_created: 'New group of services',
        service_group_deleted: 'Delete service group',
        service_group_discount_updated: 'Update service package',
        service_group_updated: 'Update service group',
        service_order_created: 'New service order',
        service_order_deleted: 'Delete service order',
        service_order_updated: 'Update service order',
        service_price_created: 'New service price',
        service_price_deleted: 'Delete service price',
        service_price_updated: 'Update service price',
        service_updated: 'Update service',
        tenant_business_created: 'New tenant',
        tenant_business_deleted: 'Delete tenant',
        tenant_business_updated: 'Update tenant',
        user_deleted: 'Delete user',
        user_updated: 'Update user'
    },
    apply: 'Apply',
    apply_changes: 'Apply Changes',
    apply_exchange: 'Apply Exchange',
    archived: 'Archived',
    are_you_sure_delete_transaction: 'Are you sure to delete the transaction?',
    arrival: 'Arrival',
    arrive: 'arrive',
    assign: 'Assign',
    assign_bookings: 'Assign Service Orders',
    assign_inventory: 'Assign Inventory',
    assign_service: 'Assign Service',
    assign_services: 'Assign Services',
    assign_to_order: 'Assign to Order',
    assigned_inventory: 'Assigned Inventory',
    assigned_services: 'Services with Assign',
    assigned_to_me: 'Assigned to me',
    assigned_vehicles: 'Assigned Vehicles',
    assignee: 'Assigned',
    assistant: 'assistant',
    assistant_plural: 'Helpers',
    assistants: 'Helpers',
    attachments: 'Attachments',
    attachments_urls: 'Attachment URLs',
    download_attachment: 'Download attachment',
    view_attachment: 'View attachment',
    failed_to_download_attachment: 'Failed to download attachment',
    attribute_key: 'Key',
    attribute_name: 'Attribute Name',
    attribute_value: 'Value',
    attributes: 'Attributes',
    availability: 'Availability',
    available: 'Available',
    available_inventory: 'Available Inventory',
    available_places: 'available places',
    no_places_available: 'no places available',
    available_service_orders: 'Service Orders Available',
    available_variables: 'Available variables',
    background_color: 'Background Color',
    background_image_url: 'URL Image Background',
    balance: 'Balance',
    bank_transfer: 'Bank Transfer',
    banking_data: 'Banking Details',
    bank_name: 'Bank / Financial Institution',
    bank_account_holder: 'Account Holder',
    bank_account_number: 'Account Number',
    bank_account_type: 'Account Type',
    bank_account_type_checking: 'Checking Account',
    bank_account_type_savings: 'Savings Account',
    bank_cbu_iban: 'CBU / CVU / IBAN / CLABE',
    bank_alias: 'Account Alias',
    bank_tax_id: 'Tax ID / CUIT / CPF',
    bank_swift_code: 'SWIFT / BIC Code',
    bank_notes: 'Banking Notes & Instructions',
    base_price_zero: 'The base price is zero',
    basic_info: 'Basic Information',
    basic_information: 'Basic Information',
    bath: 'Bathroom',
    bath_private: 'Private Bathroom',
    bath_shared: 'Shared Bathroom',
    baths: 'Bathrooms',
    baths_number: 'No. of Bathrooms',
    baths_type: 'Type of Bathrooms',
    bedroom: 'Bedroom',
    bedrooms: 'Bedrooms',
    bedrooms_number: 'Bedrooms',
    beds: 'Beds',
    beds_number: 'Beds',
    beds_type: 'Type of beds',
    bike: 'Bicycle',
    bike_rental: 'Bicycle Rental',
    bike_rental_plural: 'Bicycle Rentals',
    block: 'Block',
    boat: 'Boat',
    boat_rental: 'Boat Rental',
    boat_rental_plural: 'Boat Rentals',
    both: 'Both',
    book_service: 'Reserve Service',
    booked_services: 'Booked Services',
    booking_attributes: 'Booking Attributes',
    booking_attributes_subtitle: 'Manually entered data',
    booking_attrs: 'Reservation Attributes',
    booking_created: 'Reserve Created',
    booking_date: 'Booking Date',
    booking_details: 'Booking Details',
    booking_limits: 'Sales Limits',
    booking_successfully_created: 'Reservation created successfully',
    group_size_exceeds_capacity: 'Group Size Exceeds Capacity',
    capacity_warning_text: 'The selected service has a capacity limit of {{capacity}} pax per booking. Since your total group size is {{total}}, we will split this into {{count}} separate bookings of at most {{capacity}} pax each. Would you like to proceed?',
    all_bookings_successfully_created: 'All bookings have been successfully created!',
    booking: 'Booking',
    bookings: 'Bookings',
    bookings_and_reservations: 'Bookings',
    bookings_calendar: 'Service Agenda',
    bookings_client_provider: 'Bookings (Client/Supplier)',
    bookings_inventory_allocation: 'Inventory Allocation',
    bookings_limits_available: 'Available Reserve Limits',
    bookings_per_reservation: 'Bookings - Reservations',
    bookings_per_service: 'Bookings - Service',
    bookings_search: 'Booking Search',
    bookings_selected: 'Selected Bookings',
    bookings_timeline: 'Booking Timeline',
    bookings_without_assign: 'Unassigned Services',
    bought: 'Shopping',
    bought_by_this_client: 'Purchased by customer',
    branding: 'Brand',
    brands: 'Brands',
    breakfast_type: 'Breakfast Type',
    bulk_edit: 'Mass Edition',
    bulk_edit_businesses: 'Massive Business Edition',
    bulk_edit_services: 'Mass Edition of Services',
    bulk_email_tariff_warning: 'You are about to send a rate update to {{count}} companies. Do you want to continue?',
    bulk_price: 'Change Prices (Factor)',
    bus: 'Bus',
    bus_number: 'Bus',
    business: 'business',
    business_attributes: 'Company Attributes',
    business_balance: 'Company Balance Sheet',
    business_center: 'Business Center',
    business_name: 'Company Name',
    business_tags: 'Business Categories',
    business_tariffs: 'Business Tariffs',
    business_type: 'Business type',
    business_types: {
        activities: 'Activities & Experiences',
        agency: 'Travel Agency',
        hotel: 'Hotel',
        lodging: 'Accommodation',
        other: 'Other',
        restaurant: 'Restaurant',
        tour_operator: 'Tour Operator',
        transportation: 'Transportation'
    },
    businesses: 'Businesses',
    no_tenant_business_error: 'No business configured to perform transactions. Please create or configure a business in your account.',
    businesses_catalog: 'Business Catalog',
    businesses_description: 'Manage your companies',
    by: 'by',
    cabin: 'Cabin',
    cabins: 'Cabins',
    calendar: 'Calendar',
    calendar_inventory_items: 'Inventory Calendar',
    campaign: 'Campaign',
    campaign_send_error: 'An error occurred while sending the campaign. Please try again.',
    campaign_sent_description: 'Your campaign has been queued and the emails will be sent to the selected recipients.',
    campaign_sent_successfully: 'Campaign sent successfully',
    campaigns: 'Campaigns',
    cancel: 'Cancel',
    cancelled: 'Cancelled',
    cant_edit_booking: 'Cannot edit reservation',
    cant_edit_booking_has_inventory_locks: 'The reservation has inventory locks, it cannot be edited, you must first remove the inventory locks',
    capacity: 'Capacity',
    capacity_and_ranking: 'Capacity and Order',
    capacity_max: 'Capacity Max',
    capacity_min: 'Capacity Min',
    car: 'Car',
    car_rental: 'Car Rental',
    car_rental_plural: 'Car Rentals',
    car_rentals: 'Vehicle Rental',
    carrier: 'Transportation',
    cash: 'Cash',
    catalog: 'Catalog',
    category: 'category',
    category_name: 'Category Name',
    change_linked_service: 'Change Mirror Service',
    change_password: 'Change Password',
    change_password_description: 'Update your account password',
    check_availability: 'Check Availability',
    check_in: 'Check-in',
    check_in_hour: 'Check-in time',
    check_in_out: 'Check-In / Check-Out',
    check_out: 'Check-out',
    check_out_hour: 'Check-out time',
    check_times: 'Check-in & Check-out Times',
    checkbox: 'Checkbox',
    checking: 'Verifying',
    checking_availability: 'Checking Availability',

    child_services: 'Service package',
    child_services_description: 'Sub-services that make up this package',
    children: 'Children',
    choose_duration: 'Choose duration and paxs',
    cities: 'Cities',
    city: 'City',
    city_description: 'City where the service is offered',
    clear: 'Clean',
    clear_dates: 'Delete dates',
    clear_filters: 'Clean Filters',
    filter_by_passenger: 'Filter by passenger',
    clear_selection: 'Clear selection',
    click_to_edit_cost: 'Click to edit cost',
    click_to_edit_price: 'Click to edit price',
    client: 'Client',
    client_balance: 'Client Balance',
    client_bookings: 'Service Reservations',
    client_category_discount: 'Customer Category Discount',
    client_cost: 'Customer Cost',
    client_cost_discount: 'Desc. Customer Cost',
    client_cost_paid: 'Customer Cost Paid',
    client_discount: 'client discount',
    client_history: 'History',
    client_income_received: 'Revenue Received from Client',
    client_observations: 'Observations for the Client',
    client_reservations: 'Reservations as a Client',
    client_settlement: 'Customer Settlement',
    client_type: 'Client Type',
    client_unpaid_sells: 'Sales receivable from Customer',
    clients: 'Clients',
    clients_balance: 'Customer Balance',
    close: 'Close',
    copy: 'Copy',
    copied: 'Copied',
    admin_link: 'Admin Link',
    public_link: 'Public Link (For Clients)',
    collapse: 'Collapse',
    collapse_all: 'Collapse all',
    color: 'Color',
    comma_separated: 'Comma Separated',
    commercial_settings: 'Commercial Configuration',
    commercial_settings_desc: 'Manage default currency, discount categories, and banking details for transactions.',
    company_information: 'Company Information',
    company_name: 'Company name',
    company_name_or_name: 'Company name or yours',
    composition_mismatch_warning: 'The pax composition does not match the original group. Prices will be recalculated automatically.',
    complete_before_continue: 'Complete before continuing',
    complete_data: 'Complete Data',
    completed: 'Completed',
    concert: 'Concert',
    concert_plural: 'Concerts',
    confirm: 'Confirm',
    confirm_create_order: 'Confirm service order creation?',
    confirm_delete: 'Are you sure you want to delete this item?',
    confirm_delete_service_order: 'Are you sure you want to delete this service order?',
    confirm_delete_business: 'Are you sure you want to delete this business?',
    delete_business_warning: 'Permanently delete this business and all its configurations.',
    confirm_password: 'Confirm Password',
    confirmed: 'Confirmed',
    consumed: 'Consumed',
    contact: 'Contact Information',
    contact_information: 'Contact Information',
    contact_me: 'I want more information',
    continue: 'Continue',
    cooking: 'Kitchen',
    cooking_class: 'Cooking Class',
    cooking_class_plural: 'Cooking Classes',
    cooking_plural: 'Kitchens',
    coordinator: 'Coordinator',
    coordinator_plural: 'Coordinators',
    coordinators: 'Coordinators',
    cost: 'Cost',
    cost_amount: 'Cost Amount',
    cost_breakdown: 'Cost Breakdown',
    cost_by: 'Cost For:',
    cost_by_description: 'How will the final cost be calculated?',
    cost_by_hour: 'cost per hour',
    cost_discount_default: 'Cost Discount',
    cost_saved_successfully: 'Cost successfully saved',
    cost_summary: 'Cost Summary',
    costs: 'Costs',
    countries: {
        AE: 'United Arab Emirates',
        AR: 'Argentina',
        AT: 'Austria',
        AU: 'Australia',
        BE: 'Belgium',
        BG: 'Bulgaria',
        BO: 'Bolivia',
        BR: 'Brazil',
        BY: 'Belarus',
        CA: 'Canada',
        CH: 'Switzerland',
        CL: 'Chile',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DE: 'Germany',
        DK: 'Denmark',
        DO: 'Dominican Republic',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egypt',
        ES: 'Spain',
        ET: 'Ethiopia',
        FI: 'Finland',
        FR: 'France',
        GB: 'United Kingdom',
        GH: 'Ghana',
        GR: 'Greece',
        GT: 'Guatemala',
        HN: 'Honduras',
        HR: 'Croatia',
        HU: 'Hungary',
        ID: 'Indonesia',
        IE: 'Ireland',
        IL: 'Israel',
        IN: 'India',
        IS: 'Iceland',
        IT: 'Italy',
        JP: 'Japan',
        KE: 'Kenya',
        KR: 'South Korea',
        LT: 'Lithuania',
        LV: 'Latvia',
        LY: 'Libya',
        MA: 'Morocco',
        MT: 'Malta',
        MX: 'Mexico',
        MY: 'Malaysia',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Netherlands',
        NO: 'Norway',
        NZ: 'New Zealand',
        PA: 'Panama',
        PE: 'Peru',
        PH: 'Philippines',
        PL: 'Poland',
        PR: 'Puerto Rico',
        PT: 'Portugal',
        PY: 'Paraguay',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russia',
        SA: 'Saudi Arabia',
        SE: 'Sweden',
        SG: 'Singapore',
        SI: 'Slovenia',
        SK: 'Slovakia',
        SV: 'El Salvador',
        TH: 'Thailand',
        TN: 'Tunisia',
        TR: 'Türkiye',
        TZ: 'Tanzania',
        UA: 'Ukraine',
        UK: 'United Kingdom',
        US: 'United States',
        UY: 'Uruguay',
        VE: 'Venezuela',
        VN: 'Vietnam',
        ZA: 'South Africa'
    },
    country: 'Country',
    country_code: 'Country Code',
    cover_image: 'Cover Image',
    create: 'Create',
    create_account: 'Create Account',
    create_action_menu: 'New',
    create_another_campaign: 'Create another campaign',
    create_business: 'Create business',
    create_inventory_item: 'Create Inventory Item',
    create_item_under_this_one: 'Create Item Below',
    create_multiple: 'Create Multiples',
    create_new_business: 'Create new business',
    create_new_order: 'Create new order',
    create_new_pax: 'Create new pax',
    create_new_payment: 'Create New Payment',
    existing_pax_matches: 'Existing matching passengers',
    no_matching_pax_found: 'No matching passengers found',
    select_existing_pax: 'Select',
    create_new_person: 'Create new person',
    create_new_reservations: 'Create new reservation',
    create_new_service: 'Create new service',
    create_new_service_order: 'Create new service order',
    create_new_vehicle: 'Create new vehicle',
    create_order: 'Create Order',
    create_pax: 'Create Pax',
    create_payment: 'Create Payment',
    create_reservation: 'Create reservation',
    create_service: 'Create service',
    create_service_bookings: 'Create Orders',
    create_service_order: 'Create Service Order',
    create_staff: 'Create Staff',
    create_subscription: 'Create Subscription',
    create_template: 'Create Template',
    create_ticket: 'Create Ticket',
    create_user: 'Create User',
    create_vehicle: 'Create vehicle',
    created: 'Created',
    created_at: 'Created on',
    created_by: 'Created by',
    created_by_me: 'Created by me',
    creating_booking: 'Creating Reserve',
    creator: 'Creator',
    credit_debit_card: 'Credit/Debit Card',
    cruise: 'Cruise',
    currencies: {
        ARS: 'Argentine Peso (ARS)',
        BRL: 'Brazilian Real (BRL)',
        CLP: 'Chilean Peso (CLP)',
        COP: 'Colombian Peso (COP)',
        EUR: 'Euro (EUR)',
        GBP: 'British Pound (GBP)',
        MXN: 'Mexican Peso (MXN)',
        PEN: 'Peruvian Sol (PEN)',
        USD: 'US Dollar (USD)',
        UYU: 'Uruguayan Peso (UYU)',
        VEF: 'Venezuelan Bolívar (VEF)'
    },
    currency: 'Currency',
    currency_exchange: 'Currency Exchange',
    'current-password-incorrect': 'Current password is incorrect',
    'current-password-required': 'Current password is required',
    current_password: 'Current Password',
    current_providers: 'Current Suppliers',
    custom_attributes: 'Custom Attributes',
    custom_properties: 'Custom Properties',
    cycle: 'Cycle',
    cycle_monthly: 'Monthly',
    cycle_yearly: 'Annual',
    daily: 'Diary',
    daily_cost: 'Daily Cost',
    daily_limit: 'Lim. Day',
    dance_class: 'Dance class',
    dance_class_plural: 'Dance Classes',
    danger_zone: 'Danger Zone',
    dashboard: 'Dashboard',
    data: 'Data',
    date: 'Date',
    date_and_time_for_service: 'Date and time for service',
    date_of: 'Date of',
    date_optional_time: 'Date (optional time)',
    date_range: 'Date Range',
    dated: 'With Date',
    dates: 'Dates',
    day: 'Day',
    day_of_month: 'Day {{day}}',
    days: 'Days',
    days_arr: [
        'All days',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
        'Weekend',
        'Monday to Friday'
    ],
    days_in: 'days in',
    days_of_week: {
        friday: 'Friday',
        monday: 'Monday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        thursday: 'Thursday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday'
    },
    days_of_week_short: {
        fri: 'Fri',
        mon: 'Mon',
        sat: 'Sat',
        sun: 'Sun',
        thu: 'Thu',
        tue: 'Tue',
        wed: 'Wed'
    },
    days_range: {
        next_month: 'Next month',
        next_week: 'Next week',
        next_year: 'Next year',
        ten_days: '10 days',
        this_month: 'This month',
        this_week: 'This week',
        today: 'Today',
        tomorrow: 'tomorrow',
        yesterday: 'yesterday'
    },
    default_currency: 'Default Currency',
    default_discounts: 'Default Discounts',
    default_discounts_description: 'They can be modified in the service',
    default_language: 'Default Language',
    default_limit: 'Default Limit',
    default_limit_description: 'Maximum Pax per day',
    default_limit_helper: 'Base capacity applied to all calendar days unless a specific individual value is set.',
    default_value: 'Default Value',
    custom: 'Custom',
    custom_limit: 'Custom limit',
    restore_default: 'Restore default',
    limit_update_success: 'Limit updated successfully',
    limit_update_error: 'Error updating limit',
    limits_are_based_on_price_by: 'Daily limits consume capacity based on the scaling settings.',
    booked: 'Booked',
    available_short: 'avail.',
    booked_short: 'bkd.',
    limit_short: 'lim.',
    sold_out: 'Sold Out',
    default_tariff_template: 'Default rate template',
    delete: 'Delete',
    delete_selected: 'Delete Selected',
    delete_booking: 'Delete Service Reservation',
    delete_booking_confirmation: 'Are you sure you want to delete this reservation?',
    delete_dates: 'Delete Dates',
    delete_reservation: 'Delete Reservation',
    delete_service: 'Delete Service',
    delete_service_group: 'Delete Package',
    delete_tag: 'Delete Category',
    delete_transaction: 'This action cannot be undone',
    delete_user: 'Delete User',
    departure: 'Departure',
    departure_time: 'Departure Time',
    description: 'Description',
    destination: 'Destination',
    destination_address: 'Destination Address',
    destination_city: 'Destination City',
    destination_zone: 'Destination Zone',
    details: 'details',
    direction: 'Address',
    discard: 'Cancel',
    discount: 'Discount',
    discount_categories: 'Discount Categories',
    discount_categories_description: 'Default values, each service will modify these values',
    discount_category: 'Discount Category',
    discount_category_desc: 'Assign the commercial category applicable to this business for tariff and discount calculations.',
    discount_distributed_error: 'Error distributing the discount',
    discount_distributed_success: 'Discount successfully distributed',
    discounts: 'Discounts',
    discounts_settings_desc: 'Define discount categories and rules for services.',
    discover_experiences: 'Discover Experiences',
    display_name: 'Display name',
    distribute: 'Distribute',
    distribute_passengers: 'Distribute Passengers',
    do_you_want_to_apply_this_cost_to_linked_service: 'Do you want to apply this cost to the mirror service?',
    do_you_want_to_apply_this_price_to_linked_service: 'Do you want to apply this price to the mirror service?',
    documentation: 'Documentation',
    done: 'Done',
    done_create_another_campaign: 'Ready! Create another campaign.',
    dont_apply_client_discount: 'Do not apply customer discount',
    double_bed: 'Double Bed',
    double_beds: 'Double Beds',
    driver: 'driver',
    driver_information: 'Driver Information',
    driver_license: 'Driving License',
    driver_plural: 'Drivers',
    drivers: 'Drivers',
    drivers_license: 'Driver\'s License',
    dropoff: 'Dropoff',
    dropoff_location: 'Dropoff Location',
    due_date: 'Expiration Date',
    due_day: 'Expiration day',
    duplicate: 'Duplicate',
    update_service_data: 'Update service data',
    duration: 'Duration',
    duration_and_paxs: 'Duration and Passengers',
    duration_distance: 'Duration & Distance',
    edit: 'Edit',
    edit_attributes: 'Edit Attributes',
    edit_business: 'Edit Business',
    edit_business_tag: 'Edit Business Tag',
    edit_cost: 'Edit Cost',
    edit_inventory: 'Edit Inventory',
    edit_payment: 'Edit Payment',
    edit_price: 'Edit Price',
    edit_prices: 'Edit Prices',
    edit_properties: 'Edit Properties',
    edit_reservation: 'Edit Reservation',
    edit_selected: 'Edit Selected',
    edit_service: 'Edit Service',
    edit_service_booking: 'Edit Service Booking',
    edit_service_group: 'Edit Service Package',
    edit_service_tag: 'Edit Service Tag',
    edit_subscription: 'Edit Subscription',
    edit_tag: 'Edit Category',
    edit_tariffs: 'Edit Rate',
    edit_template: 'Edit Template',
    edit_ticket: 'Edit Ticket',
    edit_vehicle: 'Edit Vehicle',
    editing: 'Editing',
    editor: 'Editor',
    effective_date: 'Validity Date',
    email: 'Email',
    'email-and-password-required': 'Email and password are required',
    'email-required': 'Email is required',
    email_campaigns: 'Email Campaigns',
    email_history: 'Email History',
    email_send_error: 'Error sending email',
    email_sent: 'Mail sent successfully',
    email_subject: 'Email subject',
    email_subject_placeholder: 'Subject of the conversation',
    email_template: 'Email template',
    email_templates: 'Email Templates',
    emails: 'Emails',
    emails_sent_successfully: 'Emails sent successfully',
    enable_manual_price: 'Enable manual pricing',
    end: 'End',
    end_date: 'End Date',
    end_hour: 'End Time',
    end_time: 'End Time',
    ends: 'Ends',
    ends_between: 'Ends between',
    ends_today: 'Last Day',
    enter_attribute_key: 'Enter the attribute key',
    enter_attribute_value: 'Enter the attribute value',
    enter_city: 'Enter city',
    enter_default_limit: 'Enter default limit',
    enter_additional_emails: 'Enter additional emails',
    enter_different_foreigner_cost: 'Enter the cost for foreigners',
    enter_different_foreigner_price: 'Different Price for Foreigners',
    enter_different_provider_cost: 'Enter the cost for suppliers',
    enter_different_provider_price: 'Enter Different Price for Suppliers',
    enter_group_size: 'Enter Group Size',
    enter_emails: 'Enter emails',
    enter_emails_manually: 'Enter emails manually',
    enter_observations: 'Enter observations',
    enter_payment: 'Enter Payment',
    enter_search_criteria: 'Select a date and number of guests to see available services',
    enter_status_name: 'Enter reservation status name',
    equal: 'Same',
    erase: 'Delete',
    error_creating_payment: 'Error creating payment',
    error_creating_service: 'Error creating service',
    error_creating_reservation: 'Error creating reservation',
    error_creating_service_order: 'Error creating service order',
    error_deleting_payment: 'Error deleting payment',
    error_loading_vehicle: 'Error loading vehicle details',
    error_loading_vehicles: 'Error loading vehicles',
    error_sharing_reservation: 'Error sharing reservation',
    error_unsharing_reservation: 'Error removing access to reservation',
    errors: {
        'duplicate-request': 'Duplicate request, please wait.',
        'child-booking-pax-change-not-allowed': 'Passenger size changes are not allowed for included child services',
        error_duplicating_booking: 'An error occurred while duplicating the reservation.',
        error_updating_booking: 'Error updating reservation. Please try again later.',
        'person-not-found': 'Person not found',
        'person-not-found-in-booking': 'Person not found in the reservation',
        'service-booking-daily-available-limit-exceeded': 'Daily availability limit exceeded',
        'service-booking-not-found': 'Service reservation not found',
        'service-not-found': 'Service not found'
    },
    exchange: 'Exchange',
    exchange_bookings_currency: 'Convert to Single Currency',
    exchange_bookings_currency_description: 'Of all services within the reservation',
    exchange_currency: 'Exchange Currency',
    exchange_currency_description: 'Currency in which the payment was received',
    exchange_rate: 'Exchange Rate',
    exchange_rate_calculation: 'Exchange rate to convert received currency to reservation currency',
    exchange_rate_description: 'Payment was received in a different currency than the reservation',
    exchange_rates: 'Exchange Rates',
    exchange_rates_description: 'Set exchange rates for your services and reservations',
    exchange_rates_settings_desc: 'Manage currency rates and multi-currency configurations.',
    exclusive_client: 'Exclusive Client',
    exclusive_rates: 'Exclusive Prices',
    execution_status: 'Execution Status',
    exit_time: 'Exit Time',
    expand_all: 'Expand all',
    expected_amount: 'Expected Amount',
    experience: 'Experience',
    experience_plural: 'Experiences',
    external_reference: 'External Reference',
    extra_observations: 'Extra Observations',
    extra_title_info: 'Extra Info',
    facilities: 'Facilities',
    factor: 'factor',
    failed: 'Failed',
    failed_to_fetch_dashboard_data: 'Failed to fetch dashboard data',
    failed_to_load_reservation: 'Failed to load reservation',
    failed_to_send_emails: 'Error sending emails',
    favorite: 'Favorite',
    favorites: 'Favorites',
    features: 'Features',
    ferry: 'Ferry',
    festival: 'Festival',
    festival_plural: 'Festivals',
    filter: 'Filter',
    filter_by: 'Filter by',
    filter_by_category: 'Filter by category',
    filter_by_date: 'Filter by date',
    filter_by_type: 'Filter by type',
    filter_inventory: 'Filter Inventory',
    filter_rooms: 'Filter Rooms',
    filter_services: 'Filter Services',
    filter_tours: 'Filter Excursions',
    filter_transfers: 'Filter Transfers',
    filters: 'Filters',
    final_price: 'Final Price',
    finalizing_booking: 'Finalizing reservation',
    finances: 'Finances',
    financials: 'Finance',
    flight: 'Flight',
    flight_in: 'Arrival flight',
    flight_number: 'Flight Number',
    flight_out: 'Departure Flight',
    font_family: 'Font (Google Fonts)',
    for: 'for',
    for_all_providers: 'For all providers',
    for_all_providers_leave_blank: 'For all providers, leave blank',
    for_businesses: 'of companies',
    for_services: 'of services',
    foreigner: 'Foreigner',
    foreigner_price: 'Price for Foreigners',
    from: 'From',
    from_currency: 'Origin Currency',
    fuel: 'Fuel',
    fulfillment: 'Execution and Composition',
    full: 'Full',
    full_duration: 'Complete Reservation',
    full_duration_uses_all_paxs_description: 'Select between the entire reservation or a specific date/pax.',
    future: 'Future',
    general: 'General',
    general_information: 'General Information',
    go_to_business: 'Go to the Company',
    group_composition: 'Group Composition',
    group_composition_description: 'The number of adults, minors and babies that are part of the group',
    step_1_group_size: '1. Group Size',
    step_2_passengers: '2. Link Passengers',
    link_passengers: 'Link Passengers',
    in_this_booking: 'Linked to service',
    in_the_reservation: 'Available in reservation',
    define_group_size_first: 'Define the group size first in Step 1.',
    group_complete: 'All passengers linked successfully!',
    missing_passengers_warning: 'Link {{count}} more passenger(s) to match the group size.',
    extra_passengers_warning: 'There are {{count}} more passenger(s) linked than the group size.',
    link_passenger: 'Search & link passenger...',
    group_a: 'Group A',
    group_a_name: 'Group A Name',
    group_b: 'Group B',
    group_b_name: 'Group B Name',
    group_names: 'Group Names',
    paxs_selected_unselected_tooltip: '{{selected}} assigned, {{unassigned}} unassigned',

    guest: 'Pax',
    guests: 'Guests',
    guests_label: 'Guests (non-billable)',
    guests_description: 'For guides, drivers, etc. Do not affect the service price, but are taken into account for daily availability limits.',
    guests_short: 'Guests',
    guide: 'guide',
    guide_plural: 'Guides',
    guides: 'Guides',
    gym: 'Gym',
    has_a_linked_service_same_price: 'You have a service connected. Do you want to save the same price on the connected service?',
    has_access_to_provider_price: 'Access to Supplier Prices',
    has_exchange_rate: 'Has Exchange Rate',
    has_money: 'He has money in favor',
    helicopter: 'helicopter',
    helicopter_rental: 'Helicopter rental',
    helicopter_rental_plural: 'Helicopter Rentals',
    hero_image_url: 'URL Image Hero',
    hero_subtitle: 'Hero subtitle',
    hero_title: 'Title Hero',
    hide_assigned: 'Hide Assignees',
    hide_bookings: 'Hide Reservations',
    high: 'High',
    history: 'History',
    horizontal_axis_items: 'Columns Type',
    home: 'Home',
    home_type: 'Property Type',
    hostel: 'Hostel',
    hostel_room: 'Hostel Room',
    hotel: 'Hotel',
    hour: 'Hour',
    hourly: 'Per Hour',
    house: 'House',
    housing: 'Housing',
    housings: 'Housings',
    how_many: 'How many?',
    id: 'ID',
    id_card: 'ID Card',
    id_number: 'ID Number',
    id_type: 'ID Type',
    identification: 'Identification',
    im_the_owner: 'I am the owner',
    image_delete_error: 'Error deleting image',
    image_deleted: 'Image successfully deleted',
    image_upload_error: 'Error uploading image',
    image_uploaded: 'Image uploaded successfully',
    images: 'Images',
    in_progress: 'In Progress',
    in_use: 'In Use',
    include_bookings_without_dates: 'Include Services without Dates',
    included_services: 'Included Services',
    includes: 'Includes',
    income: 'Income',
    outcome: 'Outcome',
    incomes: 'Income',
    incomplete: 'Incomplete',
    incomplete_data: 'Data is missing',
    indoor_adventure: 'Adventure Inside',
    indoor_adventure_plural: 'Adventures Inside',

    infants: 'Infants',
    info: 'Info',
    information: 'Information',
    insurance_expiry: 'Insurance Expiry',
    interactive_view: 'Interactive View',
    internal_use: 'Internal Use',
    'invalid-credentials': 'Invalid credentials',
    inventory: 'Inventory',
    inventory_availability: 'Inventory Availability',
    inventory_calendar: 'Calendar',
    inventory_item: 'Inventory Item',
    inventory_items: 'Inventory',
    inventory_lock: 'Inventory Lock',
    inventory_locks: 'Inventory Locks',
    inventory_status: 'Inventory Status',
    irreversible_action: 'Irreversible action',
    issue: 'Issue',
    is_favorite: 'It\'s Favorite',
    is_refund: 'Refund',
    is_refund_description: 'If the payment is a refund, this option should be checked',
    items: 'Items',
    itinerary: 'Itinerary',
    its_my_business_info: 'This business will be registered as your own.',
    jacuzzi: 'Jacuzzi',
    join_turizi: 'Join Turizi',
    kilometers: 'kilometers',
    lake: 'Lake',
    landing: 'Landing',
    language: 'Language',
    language_class: 'Language Class',
    language_class_plural: 'Language Classes',
    language_description: 'Select the language for your user',
    language_plural: 'Languages',
    language_settings_desc: 'Change the default language and localized options.',
    languages: {
        en: 'English',
        es: 'Spanish',
        pt: 'Portuguese'
    },
    last_edited_reservations: 'Latest Edited Reservations',
    last_edited_services: 'Latest Edited Services',
    last_login: 'Last Login',
    last_maintenance: 'Last Maintenance',
    last_price: 'Latest Price',
    leave: 'leave',
    leave_blank_to_keep_current_password: 'Leave blank to keep the current password',
    leave_empty_for_all_providers: 'Leave blank for all suppliers',
    license_plate: 'License Plate',
    limit: 'Limit',
    limits: 'Limits',
    link_business: 'Link Company',
    link_existing_payment: 'Link Existing Payment',
    link_payment: 'Link Payment',
    linked_service: 'Mirror Service',
    linked_service_description: 'Price changes, discounts and booking in reservations will be synchronized with the service',
    linked_to_reservation: 'Linked to reservation',
    liquidate_reservation: 'Liquidate Reserve',
    list: 'List',
    load_more: 'Load more',
    loading: 'Loading...',
    loading_price: 'Calculating...',
    location: 'Location',
    location_and_branding: 'Location and Brand',
    locations: 'Locations',
    lodging: 'Accommodation',
    lodging_type: 'Accommodation type',
    login: 'Login',
    login_failed: 'Login failed. Please try again.',
    login_description: 'Sign in to continue',
    login_popup_hint: "Log in for clients and providers, view your special prices and balance here!",
    logistics: 'Logistics',
    logo_url: 'Logo URL',
    logout: 'Sign Out',
    logs: 'Logs',
    low: 'Low',
    maintenance: 'Maintenance',
    make_me_owner_of_this_business: 'I am legally responsible for this company',
    make_model: 'Make & Model',
    manage_housings_description: 'View and manage all housing accommodations.',
    manage_reservation_finances: 'Manage reservation finances',
    manage_reservation_payments: 'Manage reservation payments',
    manage_reservations_description: 'View and manage all reservations for businesses.',
    manage_transfers_description: 'View and manage all transfers and transportation.',
    managed_businesses: 'Managed Companies',
    managed_by_owner: 'Managed by its owner',
    managed_by_owner_description: 'This company is managed by its owner. Read-Only.',
    manager: 'Manager',
    management: 'Management',
    manifest: 'Manifest',
    manual_emails: 'Manual Emails',
    manual_entry: 'manual',
    manual_price_reason_placeholder: 'Ex. Special discount, etc...',
    mark_all_as_read: 'Mark all as read',
    mark_as_read: 'Mark as read',
    market: 'Market',
    max_bookings: 'Maximum Reserves',
    max_capacity: 'Max Capacity',
    max_pax: 'Max Paxs',
    max_pax_per_booking: 'Maximum number of passengers per reservation',
    max_pax_per_day: 'Maximum Paxes per Day',
    max_paxs: 'Max Paxs',
    max_per_day: 'Max/Day',
    meal_plan: 'Meal Plan',
    meditation: 'Meditation',
    meditation_class: 'Meditation Class',
    meditation_class_plural: 'Meditation Classes',
    meditation_plural: 'Meditations',
    medium: 'Medium',
    member: 'Member',
    members: 'Members',
    menu: 'Menu',
    metadata: 'Metadata',
    method: 'Method',
    metrics: 'Metrics',
    metrics_dashboard: 'Metrics Dashboard',
    total_money_in: 'Total Sales',
    selected_period: 'Selected period',
    all_payments: 'All payments',
    total_money_out: 'Total Money Out',
    total_paid_in: 'Total Paid In',
    total_paid_out: 'Total Paid Out',
    sold_services: 'Sold Services',
    services_sold_by_bookings: 'Services by Bookings',
    services_sold_by_paxs: 'Services by Passengers',
    services_sold_by_money_in: 'Services by Revenue',
    services_sold_by_money_out: 'Services by Costs',
    services_sold_by_margin: 'Services by Margin',
    margin: 'Margin',
    by_amount_bookings: 'By Amount of Bookings',
    by_amount_money: 'By Amount of Money',
    total_bookings_manual_prices: 'Manual Price Bookings',
    client_as_pax: 'Client as Passenger',
    client_as_pax_pct_desc: 'of reservations with a person client',
    percentage_manual_price_higher: 'Manual Price Higher than Original',
    percentage_manual_price_lower: 'Manual Price Lower than Original',
    sales_by_client: 'Sales by Client',
    group_sizes: 'Group Sizes',
    bookings_count: 'Bookings Count',
    reservations_count: 'Reservations Count',
    manual_price_label: 'Manual Price',
    higher: 'Higher',
    lower: 'Lower',
    net_balance: 'Net Balance',
    group: 'Group',
    group_size_1: '1 Passenger',
    group_size_2: '2 Passengers',
    group_size_3_4: '3-4 Passengers',
    group_size_5_8: '5-8 Passengers',
    group_size_9_plus: '9+ Passengers',
    last_30_days: 'Last 30 Days',
    this_month: 'This Month',
    this_year: 'This Year',
    all_time: 'All Time',
    manual_prices_breakdown: 'Manual Prices Breakdown',
    pax_issues_spotter: 'Pax Issues Spotter',
    missing_lastname: 'Missing Lastname',
    single_name_warning: 'Single name (no lastname detected)',
    no_lastname_found: 'No passengers with missing lastname found.',
    total_lastname_issues: 'Passengers with a single name',
    view_pax: 'View Pax',
    view_business: 'View Business',
    sailing: 'Sailing',
    adventure: 'Adventure',
    kayak: 'Kayak',
    rafting: 'Rafting',
    diving: 'Diving',
    ferry_company: 'Ferry Company',
    clean_duplicates: 'Clean Duplicates',
    duplicate_paxs: 'Duplicate Passengers',
    total_duplicate_groups: 'Duplicate Groups Found',
    clean_all_duplicates: 'Clean All Duplicates',
    no_duplicates_found: 'No duplicate passengers found.',
    auto_clean: 'Auto Clean',
    keep: 'Keep',
    confirm_clean_all_duplicates: 'Are you sure you want to clean all duplicates? This will keep the oldest record for each duplicate name and delete the rest.',
    confirm_clean_group_duplicates: 'Are you sure you want to auto clean duplicates for this passenger?',
    mileage: 'Mileage',
    min_max_pax: 'Min-Max Pax',
    min_max_pax_per_booking: 'Min-Max Paxs',
    min_pax: 'Min Paxs',
    no_min: 'No min',
    no_max: 'No max',
    min_pax_per_booking: 'Minimum number of passengers per reservation',
    min_paxs: 'Min Paxs',
    minutes: 'minutes',
    money_business_owes: 'Seller Debt',
    money_in: 'Money In',
    payment_from_client: 'Payment from Client',
    payment_to_provider: 'Payment to Provider',
    money_in_adult: 'Adult Price.',
    money_in_child: 'Lower Price',
    money_in_infant: 'Infant Price',
    money_in_senior: 'Jubilee Price.',
    money_in_total: 'Total Price',
    money_movement: 'Money Movement',
    money_movements: 'Money Movements',
    money_out: 'Money Out',
    money_out_adult: 'Adult Cost.',
    money_out_child: 'Lower Cost',
    money_out_infant: 'Infant Cost.',
    money_out_senior: 'Retirement Cost.',
    money_out_total: 'Total Cost',
    money_owed_to_business: 'Due to Seller',
    money_they_owe_us: 'They Owe Us',
    money_transaction_reasons: {
        correction: 'Adjustment',
        future_payment: 'Payment on account',
        other: 'other',
        payment: 'Payment',
        refund: 'Refund'
    },
    money_transactions: 'Account Statement',
    money_we_owe_them: 'We Owe Them',
    money_will_be_collected: 'Money will be collected',
    money_will_be_refunded: 'Money will be refunded',
    month: 'Month',
    months: {
        april: 'April',
        august: 'August',
        december: 'December',
        february: 'February',
        january: 'January',
        july: 'July',
        june: 'June',
        march: 'March',
        may: 'May',
        november: 'November',
        october: 'October',
        september: 'September'
    },
    months_short: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dec',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep'
    },
    more: 'more',
    more_paxs: 'more people',
    motel: 'Motel',
    movements: 'Movements',
    multiply_last_price_by_this_factor: 'Multiply the last price by this factor',
    music: 'Music',
    music_class: 'Music Class',
    music_class_plural: 'Music Classes',
    music_festival: 'Music Festival',
    music_festival_plural: 'Music Festivals',
    music_plural: 'Music',
    my_business_split_info_1: 'Splitting operations under different businesses helps keep the balance and accounting more organized.',
    my_business_split_info_2: 'However, ALL services will still be displayed unified under the same URL of your online store.',
    my_businesses: 'My Companies',
    my_businesses_dashboard: {
        active_services: 'Active Services',
        active_staff: '{{count}} active staff',
        advisor_issues_count: 'Advisor found {{count}} issues',
        ask_assistant: 'Ask Assistant',
        business_profile: 'Business Profile',
        business_website: 'Website',
        chart_pax: 'Passengers (PAX)',
        chart_reservations: 'Reservations',
        chart_service_bookings: 'Service Bookings',
        chart_transactions: 'Financial Transactions',
        copied: 'Copied!',
        copy_url: 'Copy Site Link',
        days_ago: '{{count}}d ago',
        error: 'Error',
        get_started: 'Get Started',
        healthy: 'Active',
        hours_ago: '{{count}}h ago',
        last_activity: 'Last Activity',
        minutes_ago: '{{count}}m ago',
        no_activity: 'No recent activity',
        no_businesses_found: 'No businesses found',
        no_businesses_found_desc: 'Create your first business backoffice to monitor operations, active tours, and financial summaries in real-time.',
        no_website: 'No website configured',
        operational_activity: 'Operational Activity (Last 7 days)',
        pending_payments: 'Pending Payments',
        phone_missing: 'missing phone',
        select_business: 'Select Business',
        staff_members: 'Staff Members',
        todays_bookings: 'Today\'s Bookings',
        warning: 'Warning',
        weekly_reservations: 'Weekly Reservations'
    },
    my_companies: 'My Companies',
    name: 'name',
    name_list_placeholder: 'Enter one name per line...',
    nationality: 'Nationality',
    net_amount: 'Net Amount',
    net_price: 'Net Price',
    'new-password-required': 'New password is required',
    new_account: 'New Account',
    new_business: 'New Business',
    new_campaign: 'New Campaign',
    new_chat: 'New Chat',
    new_cost: 'New Cost',
    new_housing: 'New Housing',
    new_inventory_item: 'New Inventory Item',
    new_money_transaction: 'New Transaction',
    new_order: 'New Order',
    new_password: 'New Password',
    new_pax: 'New Pax',
    new_person: 'New Person',
    new_price: 'New Price',
    new_register_money_transaction: 'New Transaction',
    new_reservation: 'New Reservation',
    new_reservation_payment: 'New Reservation Payment',
    new_sell_price: 'New Sale Price',
    new_service: 'New Service',
    new_service_group: 'New Service Package',
    new_service_order: 'New Service Order',
    new_staff: 'New Staff',
    new_stock_period: 'New Stock Period',
    new_tab: 'New Tab',
    new_ticket: 'New Ticket',
    new_vehicle: 'New Vehicle',
    newsletter: {
        disclaimer: 'By signing up, you agree to receive updates about Turizi',
        getStarted: 'Get started',
        gotIt: 'Got it',
        joinTitle: 'Join Turizi',
        maybeLater: 'Maybe later',
        subscribeError: 'Failed to subscribe. Please try again.',
        subscribeSuccess: 'Successfully subscribed!',
        subtitle: 'Get early access and exclusive updates',
        successMessage: 'You\'re all set! We\'ll keep you updated with our latest news.',
        title: 'Newsletter',
        welcome: 'Welcome to Turizi!'
    },
    next_10_days: 'Next 10 days',
    next_14_days: 'Next 14 days',
    next_7_days: 'Next 7 days',
    next_maintenance: 'Next Maintenance',
    next_month: 'Next month',
    night: 'Night',
    night_and_pax_pricing: 'Night and Person',
    nights: 'Nights',
    nights_pricing: 'night',
    no: 'No',
    'no-password-set': 'No password has been set for this account. Please use magic link.',
    no_availability: 'No Availability',
    no_bookings_found: 'No bookings found',
    no_categories_found: 'No categories found',
    no_change: 'No change',
    no_changes_to_apply: 'There are no changes to apply',
    no_contact: 'No contact',
    no_cost: 'No Cost',
    no_data: 'No data',
    no_date: 'No date',
    no_discount: 'No Discount',
    no_due_date: 'No due date',
    no_email_configured: 'No email configured',
    no_emails_available: 'No email addresses found',
    no_exchange_rate_found: 'No exchange rate found in database.',
    no_inventory_selected: 'No inventory selected',
    no_names: 'No names',
    no_limit: 'No limit',
    no_linked_service: 'Without Mirror Service',
    no_columns_selected: 'No columns selected',
    select_columns_instruction: 'Choose a columns type and select one or more items above to visualize bookings in the matrix.',
    no_locks_for_this_day: 'There are no locks for this day',
    no_notifications: 'No notifications',
    no_only_this_service: 'No, just this service',
    no_operational_services: 'There are no operational services assigned',
    no_payments_found: 'No payments found',
    no_payments_found_for_this_client: 'No payments found for this client',
    no_pending_tickets: 'There are no pending tickets',
    no_price: 'Priceless',
    no_price_resolved: 'Price not resolved',
    no_provider_selected: 'No supplier selected',
    no_providers: 'No suppliers',
    no_providers_assigned: 'No suppliers added',
    no_reservations: 'There are no reservations',
    no_reservation_associated_with_booking: 'No reservation associated with booking',
    no_results: 'No results found',
    no_service_orders: 'No Service Orders',
    no_services: 'There are no services',
    no_services_scheduled: 'No scheduled services',
    no_statuses_defined: 'No reservation statuses defined',
    no_template_selected: 'No template selected (using custom filters)',
    no_unpaid_reservations_found: 'No unpaid bookings found',
    merge_business: 'Merge Business',
    merge_with_another_business: 'Merge with another business',
    merge_business_description: 'Transfers all bookings, payments, services, and transactions from the selected business into this one, then permanently deletes the selected business.',
    select_business_to_merge: 'Select business to merge',
    select_source_business_to_delete: 'Select business to merge and DELETE',
    business_to_be_deleted: 'Business to be PERMANENTLY DELETED',
    business_to_be_kept: 'Destination Business (Kept)',
    merge_and_delete_warning: 'CRITICAL WARNING: All data will be transferred to the recipient business. The selected business WILL BE PERMANENTLY DELETED!',
    merge_and_delete_action: 'Merge & Delete Business',
    confirm_merge_business: 'Are you sure you want to merge this business? This action cannot be undone.',
    business_merged_successfully: 'Business merged successfully',
    error_merging_business: 'Error merging business',
    cannot_merge_business_into_itself: 'Cannot merge a business into itself',
    no_upcoming_reservations: 'No upcoming reservations',
    no_upcoming_service_orders: 'No upcoming service orders',
    no_users_shared_with: 'There are no users with shared access',
    no_vehicle_selected: 'No assigned vehicle',
    no_vehicle_type: 'No vehicle type',
    no_vehicles_assigned: 'No vehicles assigned',
    no_vehicles_found: 'No vehicles found',
    no_vehicles_scheduled_today: 'No vehicles scheduled for today',
    none: 'None',
    not_assigned: 'Unassigned',
    not_available: 'Not available',
    not_specified: 'Not specified',
    notes: 'Notes',
    notification_settings: 'Notification Settings',
    notifications_settings: 'Notification Settings',
    notifications_settings_desc: 'Configure notification preferences and receivers',
    emails_settings: 'Email Settings',
    emails_settings_desc: 'Configure organization emails and authorized sender addresses.',
    primary_email_label: 'Primary Organization Email',
    primary_email_desc: 'Default contact email address for the organization.',
    sender_emails_settings: 'Sender Emails',
    sender_emails_settings_desc: 'Configure authorized email addresses for sending statements, tariffs and bookings.',
    sender_emails_label: 'Authorized Sender Emails',
    sender_emails_help_text: 'Type an email address and press Enter to add it to your list of allowed sender emails. You can store as many emails as needed.',
    authorized_emails_count: 'Authorized Sender Addresses ({{count}})',
    primary: 'Primary',
    sender_email_placeholder: 'example@company.com',
    select_sender_email: 'Send from email',
    payment_request_receivers_label: 'Payment Request Receivers',
    payment_request_receivers_desc: 'Select which users should receive notifications when a payment is requested from your businesses.',
    pending_payment_request: 'This is a pending payment request.',
    mark_as_paid: 'Mark as Paid',
    cancel_request: 'Cancel Request',
    notifications: {
        reservation_deleted: {
            content: '{{deleter_name}} deleted reservation #{{reservation_id}}.',
            title: 'Reservation Deleted'
        },
        reservation_payment_overdue: {
            content: 'Reservation #{{reservation_id}} has an overdue payment. Amount: ${{amount}}{{currency}}. Due date: {{due_date}}',
            title: 'Reservation - Overdue Payment'
        },
        payment_overdue: {
            content: 'Payment #{{payment_id}} is overdue. Amount: ${{amount}}{{currency}}. Due date: {{due_date}}',
            title: 'Payment Overdue'
        },
        payment_request: {
            content: '{{from_business_name}} has requested a payment of {{amount}} {{currency}}.',
            title: 'Payment Request Received'
        },
        ticket_assigned: {
            content: 'You have been assigned to the ticket: {{ticket_title}}',
            title: 'New Ticket Assigned'
        },
        ticket_updated: {
            content: '{{updater_name}} has updated the ticket: {{ticket_title}}',
            title: 'Ticket Updated'
        },
        ticket_commented: {
            content: 'New comment by {{commenter_name}} on ticket: {{ticket_title}}',
            title: 'New Comment on Ticket'
        },
        ticket_overdue: {
            content: 'The ticket "{{ticket_title}}" is overdue',
            title: 'Ticket Overdue'
        },
        booking_pax_count_mismatch: {
            content: 'Reservation #{{reservation_id}} has a discrepancy between the passenger count and the assigned list.',
            title: 'Passenger Count Discrepancy'
        },
        flight_status_changed: {
            content: 'Flight {{flight_number}} status changed to "{{new_status}}".',
            title: 'Flight Status Updated'
        }
    },
    tracking_active: 'Tracking Active',
    tracked_flight_id: 'Tracked Flight ID',
    tracked_flights: 'Tracked Flights',
    today_flights: "Today's Flights",
    future_flights: 'Future Flights',
    today_and_upcoming_flights: 'Today & Upcoming Flights',
    past_flights: 'Past Flights',
    OUT: 'OUT',
    IN: 'IN',
    tracked_flights_description: 'Real-time automated flight status monitoring',
    search_tracked_flights_placeholder: 'Search by flight number, origin/destination code or status...',
    no_tracked_flights_found: 'No tracked flights found',
    no_tracked_flights_help: 'Flights assigned to service bookings will automatically appear here for tracking.',
    associated_reservations: 'Associated bookings',
    mark_section_as_read: 'Mark section as read',
    unread_count_label: '{{count}} unread',
    notifications_categories: {
        payments: 'Payments',
        reservations: 'Bookings',
        tickets: 'Tickets & Support',
        flights: 'Flights & Logistics',
        system: 'System & General'
    },
    notifications_title: 'Notifications',
    number: 'Number',
    number_of_days: 'No. Days',
    number_short: 'No.',
    observations: 'Observations',
    occupancy: 'Occupation',
    odometer: 'Mileage',
    of: 'of',
    onboarding_description: 'Enter your details to get started.',
    onboarding_title: 'Create your Work Group',
    one_url_per_line: 'One URL per line',
    ongoing: 'Ongoing',
    online_publishing: 'Online Publication',
    online_store: 'Online Store',
    online_store_description: 'Set up your company\'s online store',
    online_store_settings_desc: 'Configure online store integration and appearance settings.',
    only_pendings: 'Earrings only',
    open: 'Open',
    operated_by: 'Operated by',
    operation: {
        error: 'Error',
        info: 'Information',
        save_business: {
            error: 'Error saving business',
            success: 'Business saved successfully'
        },
        save_person: {
            error: 'Error saving person',
            success: 'Person saved successfully'
        },
        save_reservation: {
            error: 'Error updating reservation',
            success: 'Reservation updated successfully'
        },
        save_service: {
            error: 'Error saving service',
            success: 'Service saved successfully'
        },
        save_settings: {
            error: 'Error saving configuration',
            success: 'Configuration saved successfully'
        },
        save_tag: {
            error: 'Error saving tag',
            success: 'Tag saved successfully'
        },
        save_saved_report: {
            error: 'Error saving filter preset',
            success: 'Filter preset saved successfully'
        },
        save_shared_report: {
            error: 'Error sharing report',
            success: 'Report shared successfully'
        },
        delete_shared_report: {
            error: 'Error deleting shared report',
            success: 'Shared report deleted successfully'
        },
        delete_saved_report: {
            error: 'Error deleting filter preset',
            success: 'Filter preset deleted successfully'
        },
        save_template: {
            error: 'Error saving template',
            success: 'Template saved successfully'
        },
        add_subscription: {
            error: 'Error adding subscription',
            success: 'Subscription added successfully'
        },
        delete_subscription: {
            error: 'Error deleting subscription',
            success: 'Subscription deleted successfully'
        },
        add_recurring_expense: {
            error: 'Error adding recurring expense',
            success: 'Recurring expense added successfully'
        },
        delete_recurring_expense: {
            error: 'Error deleting recurring expense',
            success: 'Recurring expense deleted successfully'
        },
        cancel_recurring_expense: {
            error: 'Error canceling recurring expense',
            success: 'Recurring expense canceled successfully'
        },
        save_recurring_expense: {
            error: 'Error saving recurring expense',
            success: 'Recurring expense saved successfully'
        },
        save_vehicle: {
            error: 'Error when saving vehicle',
            success: 'Vehicle saved successfully'
        },
        success: 'Operation successful',
        warning: 'Warning'
    },
    operational_services: 'Operational Services',
    operations: 'Operations',
    operations_and_capacity: 'Operations and Capacity',
    operator: 'operator',
    operators: 'Operators',
    opertor: 'Operator',
    optional: 'Optional',
    options: 'Options',
    options_text: 'Text Options',
    or: 'Or',
    order: 'Order',
    orders: 'Orders',
    orders_calendar: 'Order Calendar',
    orders_create: 'Orders - Create',
    orders_management: 'Order Management',
    orders_show: 'Orders - Show',
    origin: 'Origin',
    origin_address: 'Origin Address',
    origin_city: 'Origin City',
    origin_zone: 'Origin Zone',
    original_cost: 'Original Cost',
    original_price: 'Original Price',
    original_total_price: 'Original Total Price',
    other: 'another',
    other_class: 'Special Class',
    other_class_plural: 'Special Classes',
    outdoor_adventure: 'Outdoor Adventure',
    outdoor_adventure_plural: 'Outdoor Adventures',
    over_paid: 'Over Paid',
    overdue: 'expired',
    overview: 'Summary',
    owes: 'Owes',
    client_surplus_money: "Client's surplus money",
    owes_money: 'owe money',
    owner: 'Owner',
    you_are_the_owner: 'You are the owner of this business.',
    packages: 'Packages',
    pages: {
        home: {
            allRightsReserved: 'All rights reserved.',
            benefitsTitle: 'Transform your operations with measurable results',
            contact: 'Contact',
            contactSubtitle: 'We are here to help you plan your perfect trip',
            contactUs: 'Contact Us',
            ctaSubtitle: 'Get started today and discover how Turizi can revolutionize your hospitality operations.',
            ctaTitle: 'Ready to transform your business?',
            discoverExperiences: 'Discover Amazing Experiences',
            emailUs: 'Email Us',
            exploreServices: 'Explore Services',
            features: {
                accounting: {
                    description: 'Complete financial management with automated invoicing, expense tracking and reporting.',
                    title: 'Accounting and Finance'
                },
                multiProperty: {
                    description: 'Manage unlimited properties from a single panel with unified inventory and pricing controls.',
                    title: 'Multi-Property Management'
                },
                revenueAnalytics: {
                    description: 'Dynamic pricing management, occupancy insights and expense control.',
                    title: 'Income/Expenses'
                },
                roomManagement: {
                    description: 'Complete room inventory, cleaning schedules and occupancy tracking.',
                    title: 'Rooms'
                },
                smartBooking: {
                    description: 'Optimize reservations for your services and properties with real-time scheduling and availability.',
                    title: 'Reservations'
                },
                vehicleManagement: {
                    description: 'Manage your fleet with tracking, maintenance schedules and route optimization.',
                    title: 'Buses and Vehicles'
                }
            },
            forBusinesses: 'For Businesses',
            from: 'From',
            getInTouch: 'Get in Touch',
            getStarted: 'Get Started Now',
            heroHighlight: 'Tourism Services',
            heroTitle: 'Platform for',
            landing: {
                automation: {
                    aiPowered: {
                        description: 'Intelligent AI assistant to help manage your operations',
                        title: 'AI Assistance'
                    },
                    analytics: {
                        description: 'Real-time information about the performance of your business',
                        title: 'Smart Analysis'
                    },
                    instantProcessing: {
                        description: 'Automate repetitive tasks and save hours of manual work',
                        title: 'Instant Processing'
                    },
                    timeTracking: {
                        description: 'Your digital assistant works 24 hours a day',
                        title: '24/7 Availability'
                    }
                },
                comparison: {
                    sectionBadge: 'Digital Transformation',
                    sectionSubtitle: 'Stop wasting time on manual processes. Turizi digitalizes and automates your entire travel business.',
                    sectionTitle: 'From Manual to Automated Operations',
                    traditional: {
                        item1: 'Paper-based or spreadsheet workflows',
                        item2: 'Manual data entry and calculations',
                        item3: 'Limited collaboration and visibility',
                        item4: 'Prone to human errors',
                        item5: 'Time-consuming repetitive tasks',
                        item6: 'No real-time updates or automation',
                        title: 'Manual Operations'
                    },
                    turizi: {
                        item1: '100% digital, cloud-based operations',
                        item2: 'Automated calculations and workflows',
                        item3: 'Real-time collaboration and updates',
                        item4: 'Error-free automated processes',
                        item5: 'Automated tasks save hours daily',
                        item6: 'Full automation and digitalization',
                        title: 'Automated Digital Platform'
                    }
                },
                cta: {
                    button: 'Start Now',
                    description: 'Join the digital revolution and automate your operations today.',
                    scheduleDemo: 'Schedule Demo',
                    startTrial: 'Start Free Trial',
                    subtitle: 'Join travel agencies and operators who are transforming their operations with automation. Start your digital transformation today.',
                    title: 'Ready to digitalize and automate your travel business?'
                },
                digitalFeatures: {
                    ai: {
                        badge: 'Powered by AI',
                        description: 'Ask questions, get instant answers and manage your operations using natural language. Our AI understands your business and provides accurate and contextual answers.',
                        feature1: 'Natural language queries',
                        feature2: 'Instant data recovery',
                        feature3: '24/7 Availability',
                        title: 'Intelligent Assistant at your Service'
                    },
                    badge: 'Digital Tools',
                    calendar: {
                        badge: 'Smart Programming',
                        description: 'View all your reservations, tours and activities on a unified calendar. Avoid conflicts and automatically optimize resource allocation.',
                        feature1: 'Unified view of all services',
                        feature2: 'Automatic conflict detection',
                        feature3: 'Resource optimization',
                        title: 'Automated Calendar Management'
                    },
                    finance: {
                        badge: 'Financial Control',
                        description: 'Track payments, balances and financial metrics in real time. Automate billing and payment reminders to improve cash flow.',
                        feature1: 'Real-time balance tracking',
                        feature2: 'Automated payment reminders',
                        feature3: 'Multi-currency support',
                        title: 'Complete Financial Visibility'
                    },
                    title: 'Digitize Every Aspect of your Agency'
                },
                features: {
                    groupManagement: {
                        description: 'Digitally manage complex group bookings. Automate traveler assignments, room allocations, and service coordination in one platform.',
                        title: 'Automated Group Management'
                    },
                    instantQuotes: {
                        description: 'Generate professional digital proposals instantly with automated pricing calculations and availability verification.',
                        title: 'Instant Digital Quotes'
                    },
                    multiDestination: {
                        description: 'Automate complex multi-city tour coordination with smart supplier integration and real-time availability syncing.',
                        title: 'Multi-destination Automation'
                    },
                    payments: {
                        description: 'Digitalize your finances with automated invoicing, payment tracking, and multi-currency support.',
                        title: 'Automated Payment Processing'
                    },
                    sectionBadge: 'Digital Automation',
                    sectionSubtitle: 'From initial inquiry to final payment, our platform automates and digitalizes every aspect of travel agency operations.',
                    sectionTitle: 'Automate Your Entire Travel Business',
                    security: {
                        description: 'Bank-level encryption and GDPR compliance ensure your digital operations are safe and secure.',
                        title: 'Secure Digital Infrastructure'
                    },
                    smartScheduling: {
                        description: 'Automatic itinerary creation with AI-powered conflict detection and optimization for seamless operations.',
                        title: 'Intelligent Scheduling Automation'
                    }
                },
                footer: {
                    about: 'About',
                    api: 'API',
                    blog: 'Blog',
                    careers: 'Careers',
                    community: 'Community',
                    company: 'Company',
                    contact: 'Contact',
                    copyright: '© 2024 Turizi. All rights reserved.',
                    docs: 'Documentation',
                    features: 'Features',
                    gdpr: 'GDPR',
                    helpCenter: 'Help Center',
                    integrations: 'Integrations',
                    legal: 'Legal',
                    pricing: 'Pricing',
                    privacy: 'Privacy',
                    product: 'Product',
                    resources: 'Resources',
                    security: 'Security',
                    terms: 'Terms',
                    webinars: 'Webinars'
                },
                hero: {
                    automation: 'Complete Automation and Digitization of Processes',
                    badge: 'The modern alternative to Ezus',
                    noCreditCard: 'No credit card • 15 minute setup • Cancel anytime',
                    startTrial: '14 Day Free Trial',
                    subtitle: 'Transform your operations with the all-in-one platform designed for',
                    subtitle2: 'travel agencies and tour operators',
                    title: 'Digitalization and Automation for Travel Agencies',
                    watchDemo: 'Watch Demo'
                },
                nav: {
                    contact: 'Contact',
                    demo: 'Demo',
                    features: 'Features',
                    pricing: 'Pricing',
                    signIn: 'Sign In',
                    startFreeTrial: 'Free Trial'
                },
                showcase: {
                    badge: 'Complete Platform',
                    title: 'Everything You Need in One Place'
                },
                stats: {
                    agencies: 'Travel Agencies',
                    satisfaction: 'Customer Satisfaction',
                    setupTime: 'Average Setup Time',
                    travelers: 'Travelers Managed'
                },
                workflow: {
                    sectionBadge: 'Digital Transformation',
                    sectionTitle: 'Digitalize and automate your entire workflow',
                    step1: {
                        description: 'Transform your services, accommodations and activities into digital assets with automated pricing and real-time availability.',
                        title: 'Digitalize Your Inventory'
                    },
                    step2: {
                        description: 'Use our drag-and-drop digital interface to create itineraries with automated pricing, availability checks, and conflict detection.',
                        title: 'Automate Itinerary Creation'
                    },
                    step3: {
                        description: 'Automated proposal generation with one click. Digital documents include maps, photos and detailed breakdowns.',
                        title: 'Generate Digital Proposals Instantly'
                    },
                    step4: {
                        description: 'Digital dashboards for bookings, payments and documents. Automated reminders and notifications keep operations running smoothly.',
                        title: 'Automated Operations Management'
                    }
                }
            },
            limitedAvailability: 'Limited availability',
            localExpertise: 'Local Expertise',
            localExpertiseDesc: 'Deep knowledge of destinations and hidden gems',
            login: 'Login',
            or: 'or',
            ourBusinesses: 'Our Partner Businesses',
            ourServices: 'Our Services',
            perPerson: 'per person',
            publishYourService: 'Learn More',
            qualityService: 'Quality Service',
            qualityServiceDesc: 'Personalized attention and memorable experiences',
            questions: 'Questions? Contact us at',
            sendMessage: 'Send us a message',
            servicesSubtitle: 'Choose from our carefully selected tours and activities',
            variedOptions: 'Varied Options',
            variedOptionsDesc: 'Wide range of tours for every traveler',
            viewAllServices: 'View all {{count}} services',
            viewDetails: 'View Details',
            welcome: 'Welcome to {{name}}',
            whyChooseUs: 'Why Choose Us?',
            whyChooseUsSubtitle: 'Your trusted partner for unforgettable trips'
        }
    },
    paid: 'Paid',
    paid_amount: 'Paid',
    remaining_amount: 'Remaining',
    surplus: 'Surplus',
    painting: 'Painting',
    painting_class: 'Painting Class',
    painting_class_plural: 'Painting Classes',
    painting_plural: 'Paintings',
    parent_inventory_item: 'Top Item',
    parking: 'Parking',
    partial: 'Partial',
    partially_paid: 'Partially Paid',
    partially_refunded: 'Partially Refunded',
    passenger_data: 'Passenger details',
    passenger_info: 'Passenger information',
    passenger_type: 'Passenger Type',
    passengers: 'Passengers',
    passengers_per_day: 'People per Day',
    passport: 'Passport',
    password: 'Password',
    'password-required': 'Password is required',
    password_changed_successfully: 'Password changed successfully',
    passwords_do_not_match: 'Passwords do not match',
    paste_a_list_of_names: 'Paste a list of names',
    pax: 'pax',
    pax_count: 'Pax',
    pax_assigned_count: '{{assigned}} / {{total}} assigned',
    pax_description: 'Person or Group that travels and pays for the service',
    pax_number_question: 'No. of people',
    pax_pricing: 'Person',
    pax_seats: 'Paxs / Seats',
    paxs: 'Paxs',
    paxs_capacity: 'Pax Capacity',
    paxs_capacity_description: 'Leave empty so as not to limit the capacity of this item',
    paxs_catalog: 'Paxs Catalog',
    paxs_description: 'Manage your passengers',
    payed_amount: 'Paid',
    payee: 'Payee',
    payer: 'Payer',
    payer_information: 'Payer Information',
    payment: 'Payment',
    applied_amount: 'Applied Amount',
    applied_amounts: 'Applied Amounts',
    distribute_evenly: 'Distribute Evenly',
    fill_needed_amounts: 'Fill Required Balances',
    payment_created_successfully: 'Payment created successfully',
    payment_date: 'Payment Date',
    payment_deleted_successfully: 'Payment deleted successfully',
    payment_done: 'Payment Made',
    payment_done_desc: 'The payment has been made correctly',
    payment_failed: 'Payment Failed',
    payment_full: 'Full Payment',
    payment_intent: 'Payment Intent',
    payment_issue_warning: 'Invalid amount or same payer/payee',
    payment_method: 'Payment Method',
    payment_methods: {
        bank_transfer: 'Bank Transfer',
        card: 'Credit/Debit Card',
        cash: 'Cash',
        paypal: 'PayPal',
        reconciling: 'Conciliation',
        service_reciprocity: 'Service by Reciprocity',
        stripe: 'Stripe',
        wallet_transfer: 'Digital Wallet'
    },
    by_payment_method: 'By Payment Method',
    no_transactions: 'No transactions',
    no_overdue_payments: 'No overdue payments',
    payment_partial: 'Partial Payment',
    payment_pending: 'Pending',
    payment_status: 'Payment Status',
    reconcile_payments: 'Reconcile Payments',
    see_reconciliation_details: 'See Reconciliation Details',
    reconciliation_triggered_successfully: 'Reconciliation completed successfully',
    reconciliation_failed: 'Reconciliation failed',
    reconciliation_executed_successfully: 'Reconciliation executed successfully',
    match: 'Match',
    find_matches_title: 'Find Reconciliation Matches',
    no_matches_found: 'No unconnected matches found.',
    reconcile_confirm_title: 'Reconcile Payments',
    reconcile_confirm_desc: 'Select the proposed matches you want to execute. Only unconnected payments and reservations are processed.',
    reconcile_execute_button: 'Execute Reconciliation',
    reconcile_match_payment: 'Payment',
    reconcile_match_reservation: 'Reservation',
    reconcile_match_amount: 'Amount to Link',
    reconcile_find_error: 'Failed to retrieve reconciliation matches',
    payment_type: 'Payment Type',
    payment_types: {
        cancellation_fee: 'Cancellation Fee',
        fee: 'Rate',
        full: 'Total',
        partial: 'Partial',
        refund: 'Refund'
    },
    payments: 'Payments',
    payments_income: 'Collections',
    payments_outcome: 'External Payments',
    payments_history: 'Payment History',
    paypal: 'PayPal',
    pdf_view: 'PDF view',
    pending: 'Pending',
    pending_payments: 'Pending Payments',
    pending_tickets: 'Pending Tickets',
    people: 'People',
    percentage: 'Percentage',
    period: 'Period',
    person: 'person',
    person_type_pricing: 'Per Person',
    person_updated_successfully: 'Person updated successfully',
    persons: 'persons',
    phone: 'phone',
    phones: 'Telephones',
    photography: 'Photography',
    photography_class: 'Photography Class',
    photography_class_plural: 'Photography Classes',
    photography_plural: 'Photographs',
    pickup: 'Pickup',
    pickup_date: 'Pickup Date',
    pickup_location: 'Pickup Location',
    plane: 'airplane',
    plane_rental: 'Airplane Rental',
    plane_rental_plural: 'Aircraft Rentals',
    planned_services: 'Scheduled Services',
    please_select_start_and_end_time: 'Please select the start and end date and time',
    please_select_the_passengers_for_this_booking: 'Select passengers for this reservation',
    policies: 'Policies',
    postal_code: 'Postal Code',
    precio_manual: 'manual price',
    preview: 'Preview',
    price: 'Price',
    pvp: 'PVP',
    standard_retail_price: 'Standard Retail Price (PVP)',
    price_breakdown: 'Price Detail',
    price_by: 'Price By',
    price_by_description: 'The price will be calculated per day, pax or service',
    price_by_hour: 'per Hour',
    price_by_night: 'per Night',
    price_by_night_and_pax: 'per Night and Person',
    price_by_pax: 'per Person',
    price_by_service: 'per Service',
    price_calculated_by: 'Price Calculated By:',
    price_cost_error: 'The selling price must be greater than the cost price',
    price_factor: 'Price Factor',
    price_period: 'Price Period',
    price_saved_successfully: 'Price successfully saved',
    price_summary: 'Price Summary',
    prices: 'Prices',
    pricing: 'Pricing',
    pricing_error_desc: 'Failed to retrieve prices for one or more services. Please check dates and parameters.',
    pricing_error_title: 'Pricing Error',
    primary_color: 'Primary Color',
    privacy: 'Privacy',
    private: 'Private',
    private_categories: 'Private Categories',
    private_fm: 'Private',
    private_room: 'Private Room',
    private_service: 'Private',
    private_vehicle: 'Private Vehicle',
    privates: 'Privates',
    processing: 'Processing',
    processing_your_request: 'Processing your request',
    products: 'Products',
    profile: 'Profile',
    profit: 'Profit',
    proportional: 'Proportional',
    provided_by_other: 'Provided by third parties',
    provider: 'Provider',
    provider_only_bookings: 'Service Reservations Provided by',
    provider_price: 'Supplier Price',
    provider_services: 'Service Provider',
    provider_specific_cost: 'This cost will apply to a specific provider',
    provider_specific_price: 'This price will apply to a specific provider',
    providers: 'Providers',
    providing_services: 'Services provided',
    province: 'Province',
    public: 'Public',
    public_categories: 'Public Categories',
    public_rank: 'Public Ranking (web/rate)',
    public_services: 'Share Rate',
    public_tariffs: 'Public Rate',
    publish_price: 'Publish Price in Tariff?',
    publish_price_description: 'Enable this option to display this service and its prices in the online store for external customer purchases.',
    publish_prices: 'Publish Services Prices in Tariff?',
    published: 'Published',
    published_prices: 'Published Prices',
    purchase_date: 'Purchase Date',
    quantity: 'Units',
    quantity_description: 'Quantity of the same item',
    rack: 'Rack',
    rank: 'Ranking',
    ready: 'Ready',
    reason: 'Reason',
    received_currency: 'Received Currency',
    recipient: 'Recipient',
    recipients: 'Recipients',
    recipients_list: 'Recipient List',
    records: 'Records',
    refresh: 'Refresh',
    refund: 'Refund',
    refunded: 'Refunded',
    regime: 'Regime',
    regimen: 'Regimen',
    register_money_transaction: 'Register Payment',
    regular: 'Regular',
    regular_schedule: 'Regular',
    regulars: 'Regulars',
    reply_to_existing_conversation: 'Reply to an existing email conversation',
    remove: 'Remove',
    remove_bookings: 'Take out Bookings',
    remove_from_order: 'Remove from Order',
    remove_from_reservation: 'Remove from reserve',
    remove_pax: 'Remove Pax',
    remove_staff: 'Remove Staff',
    remove_stock_period: 'Delete Stock Period',
    remove_stock_period_confirmation: 'Are you sure you want to eliminate this stock period?',
    remove_stock_period_confirmation_message: 'Are you sure you want to eliminate this stock period?',
    remove_stock_period_confirmation_title: 'Delete Stock Period',
    rental_house: 'Rental House',
    required_info: 'Required Information',
    required_information: 'Required Information',
    required_number_of_service_orders: 'Number of Orders Required',
    required_service_orders: 'Required Service Orders',
    requested_amount: 'Requested Amount',
    linked_payments: 'Linked Payments',
    payments_count: '{{count}} payments',
    unlinked_payments: 'Unlinked Payments',
    reservation: 'Reservation',
    reservation_cancelled: 'Canceled',
    reservation_cancelled_plural: 'Canceled',
    reservation_completed: 'Completed',
    reservation_confirmed: 'Confirmed',
    reservation_confirmed_plural: 'Confirmed',
    reservation_in_progress: 'In Progress',
    reservation_finished: 'Finished',
    reservation_date: 'Reservation Date',
    reservation_dates: 'Reservation Dates',
    reservation_details: 'Reservation Details',
    reservation_future: 'Coming soon',
    reservation_id: 'Reservation ID',
    reservation_number: 'Reservation Number',
    reservation_ongoing: 'In progress',
    reservation_paxs: 'Reservation Paxs',
    reservation_payments: 'Reservation Payments',
    reservation_pending: 'Quote',
    reservation_pending_plural: 'Quotes',
    reservation_price: 'Reservation Price',
    reservation_shared_successfully: 'Reservation shared successfully',
    reservation_status: 'Reservation Status',
    reservation_statuses: 'Reservation Statuses',
    reservations_by_status: 'Reservations by Status',
    reservation_unshared_successfully: 'Reservation access successfully removed',
    reservation_web_created: 'Website',
    reservations: 'Reservations',
    reservation_summary: 'Reservation Summary',
    quotes: 'Quotes',
    quote: 'Quote',
    new_quote: 'New Quote',
    quote_status: 'Quote Status',
    quote_dates: 'Quote Dates',
    create_quote: 'Create Quote',
    error_creating_quote: 'Error creating quote',
    accepted: 'Accepted',
    rejected: 'Rejected',
    expired: 'Expired',
    totals: 'Totals',
    observations_placeholder: 'Write observations here...',
    quote_deleted: 'Quote deleted successfully',
    error_deleting_quote: 'Error deleting quote',
    confirm_delete_service: 'Are you sure you want to remove this service?',
    service_deleted: 'Service removed successfully',
    error_deleting_service: 'Error removing service',
    booking_updated: 'Booking updated successfully',
    error_updating_booking: 'Error updating booking',
    quote_status_updated: 'Status updated successfully',
    quote_client_updated: 'Client updated successfully',
    quote_observations_updated: 'Observations updated successfully',
    quote_details: 'Quote Details',
    no_services_quote: 'No services added to this quote yet',
    add_first_service: 'Add First Service',
    no_quotes_found: 'No quotes found',
    manual_price: 'Manual Price',
    please_select_business: 'Please select a business',
    select_business_to_view_assignments: 'Select a business to view assignments',
    select_business_placeholder: 'Select a business...',
    reservations_calendar: 'Reservation Calendar',
    reservations_description: 'Manage your service reservations',
    reservations_payments: 'Reservation Payments',
    reservations_sold: 'Reservations Sold',
    reserved_price: 'Reserved Price',
    reset_price: 'Reset price',
    reset_cost: 'Reset cost',
    reset_to_template: 'Reset',
    resolve_payment_for_reservation: 'Resolve Payment (Booking #{{id}})',
    resources_and_services: 'Resources and Services',
    restaurant: 'Restaurant',
    restaurants: 'Restaurants',
    result: 'Result',
    results: 'Results',
    retry_campaign: 'Failed. try again',
    revenue: 'Income',
    river: 'river',
    road: 'Terrestrial',
    role: 'role',
    room: 'Room',
    room_category: 'Room Category',
    room_details: 'Room Details',
    room_number: 'Room No.',
    room_plural: 'Rooms',
    room_type: 'Room Type',
    rooms: 'Rooms',
    rooms_available: 'Rooms available',
    route: 'Tour',
    route_points: 'Tour Points',
    routing: 'Route',
    sales: 'Sales',
    save: 'Save',
    save_as_new_template: 'Save as new template',
    save_and_close: 'Save and Close',
    save_changes: 'Save Changes',
    save_current_preset: 'Save Current Filters',
    save_new_cost: 'Save New Cost',
    save_new_name: 'Save New Name',
    save_new_price: 'Save new price',
    save_preset_dialog_title: 'Save Filter Preset',
    save_observations: 'Save',
    save_providers: 'Save Suppliers',
    save_to_linked_service: 'Save to mirror service',
    saved_presets: 'Saved Presets',
    saved_to_linked_service: 'Saved to connected service',
    saved_to_linked_service_cost: 'Saved to connected service',
    saved_to_linked_service_price: 'Saved to connected service',
    saving: 'Saving...',
    saving_providers: 'Saving suppliers...',
    saving_providers_success: 'Suppliers successfully saved',
    schedule: 'Schedule',
    scheduling: 'Programming',
    search: 'Search',
    search_all: 'Search in all',
    search_businesses: 'Search Companies',
    search_by: 'Search By',
    search_client: 'Search Client',
    search_clients: 'Search Clients',
    search_existing_person: 'Search existing person',
    search_inventory: 'Search inventory',
    search_inventory_items: 'Search Inventory',
    search_rooms: 'Search Rooms',
    search_tours: 'Search Excursions',
    search_transfers: 'Search Transfers',
    seats_available: 'seats available',
    secondary_color: 'Secondary Color',
    see_all: 'See All',
    see_vehicles: 'See Vehicles',
    select: 'Select',
    select_all: 'Select all',
    select_all_filtered: 'Select all filters',
    select_an_existing_payment_from_client: 'Select an existing payment from client: {{name}}',
    select_assignee: 'Select Assigned',
    select_business: 'Select Company',
    select_business_type: 'Select your business type',
    select_businesses: 'Select the companies',
    select_businesses_to_edit: 'Select businesses to edit',
    select_categories: 'Select Categories',
    select_campaign: 'Select Campaign',
    select_city: 'Select City',
    select_client: 'Select Client',
    please_select_client: 'Please select client',
    click_to_edit: 'Click to edit',
    select_coordinator: 'Select Coordinator',
    select_cost_by: 'Cost For:',
    select_country: 'Select Country',
    select_currency: 'Select Currency',
    select_currency_for_all_bookings: 'Select Currency for all bookings',
    select_date: 'Select Date',
    select_date_range: 'Select Dates',
    select_date_time_and_guests: 'Select date, time and number of guests',
    select_destination: 'Select Destination',
    select_destination_city: 'Select Destination City',
    select_due_date: 'Select Expiration Date',
    select_image: 'Select Image',
    select_inventory: 'Select Inventory',
    select_inventory_item: 'Select Inventory',
    select_items: 'Select items',
    select_items_placeholder: 'Pick items to show as columns',
    select_linked_service: 'Select Mirror Service',
    select_money_destination: 'Select Recipient',
    select_money_origin: 'Select Sender',
    select_order: 'Select Order',
    select_origin: 'Select Origin',
    select_pax: 'Select Pax',
    select_paxs: 'Select Paxes',
    select_payee: 'Select Payee',
    select_payer: 'Select Payer',
    select_payment: 'Select payment',
    select_pickup_city: 'Select Pickup City',
    select_price_by: 'Price for:',
    select_provider: 'Select Supplier',
    select_emails: 'Select email addresses',
    select_recipient: 'Select Recipient',
    select_recipients: 'Select Recipients',
    select_role: 'Select Role',
    select_seller_business: 'Select Seller Company',
    select_service: 'Select Service',
    select_service_for_group: 'Select Service for Package',
    select_service_for_reservation: 'Select Service For Reservation',
    select_service_type: 'Select Type of Service',
    select_preset: 'Select a filter preset...',
    select_staff: 'Select Staff',
    select_template: 'Select Template',
    select_type: 'Select Type',
    select_user: 'Select User',
    select_vehicle: 'Select Vehicle',
    select_zone: 'Select Zone',
    selected: 'Selected',
    selected_inventory: 'Selected Inventory',
    selected_items_total: 'Selected Items Total',
    selected_paxs: 'Selected Paxs',
    selected_provider: 'Selected Supplier',
    selected_service: 'Selected Service',
    selected_staff: 'Selected Staff',
    self: 'We',
    self_attributes: 'Attributes',
    self_attrs: 'Attributes',
    sell_amount: 'Sales Amount',
    sell_costs: 'Sales Costs',
    sell_prices: 'Sales Prices',
    sell_prices_discounts: 'Discounts on Sales Prices',
    seller: 'Seller',
    seller_and_provider_bookings: 'Service Reservations Sold and Provided by',
    seller_business: 'Selling Company',
    seller_business_description: 'This is to keep track of sales of services.',
    seller_only_bookings: 'Service Reserves Sold by',
    selling_limit: 'Sale Limit',
    selling_services: 'Services You Sell',
    send: 'Send',
    send_balance_email: 'Send Balance Email',
    send_period_balance_email: 'Send Period Summary Email',
    send_all_balance_email: 'Send All-Time Balance Email',
    send_campaign: 'Send campaign',
    send_email: 'Send Mail',
    send_tariffs_email: 'Send Rate Email',
    send_reservations_payment_status_email: 'Send Reservations Payment Status Email',
    reservations_payment_status: 'Reservations Payment Status',
    payment_status_filter: 'Filter by Payment Status',
    custom_message_optional: 'Custom message (optional)',
    custom_message_placeholder: 'Write an additional message or note to include in the email...',

    seniors: 'Seniors',
    retired: 'Retired',
    retired_plural: 'Retired',
    show_retired: 'Show as Retired',
    show_retired_description: 'Use "Retired" instead of "Senior" for this service',
    sent: 'Sent',
    sent_to: 'Sent to',
    service: 'Service',
    'service-booking-daily-available-limit-exceeded': 'Daily availability limit exceeded',
    service_attributes: 'Service Attributes',
    service_booked_in: 'Service Reservations',
    service_booking_price: 'Service price',
    service_bookings: 'Service Bookings',
    service_categories: 'Service Categories',
    service_category: {
        activity: 'Activity',
        agency: 'Agency',
        apartment: 'Apartment',
        cabin: 'Cabin',
        cabins: 'Cabins',
        car_rental: 'Car Rental',
        hostel_room: 'Hostel Room',
        hotel: 'Hotel',
        house: 'House',
        other: 'Other',
        room: 'Hotel Room',
        tour: 'Tour',
        transfer: 'Transfer',
        villa: 'Villa'
    },
    service_composition: 'Service Composition',
    service_configuration: 'Settings',
    service_date: 'Service Date',
    service_day: 'Service Day',
    service_default_duration: 'Standard Duration of Service',
    service_definition: 'Service Definition',
    service_details: 'Service Details',
    service_discounts: 'Discounts',
    service_group: 'Service Package',
    service_group_discount: 'Service Package Discount',
    service_group_plural: 'Service Packages',
    service_groups: 'Service Packages',
    service_groups_plural: 'Service Packages',
    service_has_attrs_warning: 'Remove fallback attributes to add sub-services.',
    service_has_children_warning: 'It does not support reservation attributes because it is a package.',
    service_key: 'Service Key',
    service_name: 'Service Name',
    service_not_available: 'The service is not available for the selected dates',
    service_not_found: 'Service not found',
    service_number: 'Service No.',
    service_order: 'Service Order',
    service_order_attributes: 'Service Order Attributes',
    service_order_bookings: 'Service Reservations',
    service_order_bookings_description: 'Service Reservations in this Order',
    service_orders: 'Service Orders',
    service_orders_settings_desc: 'Manage order options, custom fields, and numbering rules.',
    service_paxs: 'Service Paxs',
    service_period_end: 'Service End Date',
    service_period_start: 'Service Start Date',
    service_provider: 'Service Provider',
    service_selected: 'Selected Service',
    service_tags: 'Service Categories',
    service_title: 'Service Title',
    service_type: 'Type of Service',
    services: 'Services',
    services_availability: 'Service Availability',
    services_in_this_order: 'Services in this Order',
    services_landing: {
        categories: {
            rooms_description: 'Hotel rooms, guest rooms, and accommodation services',
            tours_description: 'Guided tours, excursions, and sightseeing experiences',
            transfers_description: 'Airport transfers, city transfers, and transportation services'
        },
        no_results: 'No services found matching',
        search_placeholder: 'Search services...',
        subtitle: 'Discover and book services for your business'
    },
    services_table: 'Services Table',
    services_with_calculated_prices: 'Services with New Prices',
    services_without_dates: 'Undated Services',
    services_without_vehicles: 'No vehicle assignment',
    set_coordinator: 'Set Coordinator',
    set_coordinator_all_bookings: 'Set Coordinator for All Bookings',
    set_provider: 'Set Provider',
    set_provider_all_bookings: 'Set Provider for All Bookings',
    set_discount_scheme_for_all_services: 'Establish Discount Scheme for All Services',
    set_group_composition_before_services: 'Configure group composition to check service availability',
    settings: 'Settings',
    settings_subtitle: 'Configure and customize your workspace settings and preferences.',
    share: 'Share',
    share_reservation: 'Share Reservation',
    share_service: 'Share Service',
    share_services: 'Share Services',
    share_report: 'Share Report',
    share_link_copied: 'Link copied to clipboard!',
    shared_report_title: 'Shared Bookings Report',
    viewing_shared_report_desc: 'Viewing Shared Bookings Report (Read-Only)',
    shared_reports: 'Shared Reports',
    sharing_one_service: 'Sharing 1 service',
    sharing_multiple_services: 'Sharing {{count}} services',
    sharing_services_description: 'Configure client permissions below',
    mixed_access: 'Mixed access',
    partial_access: 'Partial access',
    remove_access: 'Remove access',
    services_shared_successfully: 'Services shared successfully',
    error_sharing_services: 'Error sharing services',
    services_unshared_successfully: 'Services access successfully removed',
    error_unsharing_services: 'Error removing services access',
    shared_kitchen: 'Shared Kitchen',
    shared_room: 'Shared Room',
    shared_vehicle: 'Shared Vehicle',
    shared_with_me: 'Shared with me',
    show: 'Show',
    show_bookings: 'Show Reservations',
    show_more: 'See more',
    show_on_main_page: 'Show on main page',
    show_only_services_without_vehicles: 'Show only services without vehicles',
    show_service_orders: 'See Orders',
    showing_results: 'Showing {{count}} of {{total}} results',
    signIn: 'Sign in',
    signature_provider: 'Operator: Stamp, Signature, Clarification',
    signature_seller: 'Seller: Stamp, Signature, Clarification',
    signature_transport_company: 'Stamp, Signature, Clarification, Transport Company',
    signature_travel_agency: 'Stamp, Signature, Clarification, Travel Agency',
    signingIn: 'Signing in...',
    single_bed: 'Single bed',
    single_beds: 'Single Beds',
    single_provider: 'sole supplier',
    sold: 'Sales',
    sold_by: 'By',
    sold_by_long: 'Sold by',
    sold_by_other: 'Sold by third parties',
    sort_by: 'Sort by',
    sort_by_name: 'Sort by Name',
    sort_by_price: 'Sort by Price',
    spacial_requirements: 'Special requirements',
    spacial_view: 'Spatial View',
    special: 'Special',
    special_pricing_available_only_for: 'Special prices available only for',
    special_pricing_target: 'Special Pricing Recipient',
    split: 'Split',
    split_pax_group: 'Split Pax Group',
    splitting_original_group: 'Splitting Original Group',
    staff: 'Staff',
    staff_category_description: 'Select or enter a new category',
    staff_description: 'Employee or team member providing services',
    staff_paxs: 'Staff and Paxes',
    staff_tag: {
        coordinator: 'Coordinator',
        driver: 'Driver',
        guide: 'Guide',
        sales: 'Sales'
    },
    stars: 'Stars',
    insufficient_capacity: 'Insufficient capacity',
    start: 'Start',
    start_date: 'Start Date',
    start_hour: 'Start Time',
    start_time: 'Start Time',
    starts_between: 'Starts between',
    status: 'Status',
    status_active: 'Active',
    status_paused: 'Paused',
    status_canceled: 'Canceled',
    total_expenses_by_currency: 'Total Expenses by Currency',
    subscription_readonly_warning: 'This recurring expense is read-only and cannot be modified.',
    status_color: 'Status Color',
    status_color_already_exists: 'Status color already exists',
    status_color_required: 'Status color is required',
    status_inactive: 'Inactive',
    status_name_already_exists: 'Status name already exists',
    status_name_required: 'Status name is required',
    status_overdue: 'expired',
    status_open: 'Open',
    status_pending: 'Pending',
    status_in_progress: 'In Progress',
    status_completed: 'Completed',
    status_closed: 'Closed',
    status_paid: 'Paid',
    status_cancelled: 'Cancelled',
    priority_low: 'Low',
    priority_medium: 'Medium',
    priority_high: 'High',
    priority_urgent: 'Urgent',
    payment_request: 'Payment Request',
    log_direct_payment: 'Record Direct Payment',
    payment_type_selector: 'Transaction Type',
    generate_tax_voucher: 'Generate AFIP Tax Voucher',
    invoice_generation_failed: 'Invoice generation failed',
    statuses: 'Statuses',
    stay: 'Accommodation',
    stay_plural: 'Accommodations',
    stock: 'stock',
    stock_control: 'Inventory Control',
    stock_control_description: 'Service Orders and Inventory will be synchronized with the service',
    store: 'Store',
    store_name: 'Store Name',
    store_website_description: 'Where is the online store hosted?',
    stripe: 'Stripe',
    styling_branding: 'Style and Brand',
    submit: 'Send',
    subscribe: 'Subscribe',
    subscription: 'Subscription',
    subscription_business: 'Business',
    subscriptions: 'Subscriptions',
    expenses: 'Expenses',
    expense: 'Expense',
    recurring: 'Recurring',
    auto_payment: 'Auto Payment',
    recurring_expenses: 'Recurring Expenses',
    recurring_expense: 'Recurring Expense',
    delete_recurring_expense: 'Delete Recurring Expense',
    delete_recurring_expense_confirmation: 'Are you sure you want to delete the recurring expense {{name}}?',
    cancel_recurring_expense: 'Cancel Recurring Expense',
    cancel_recurring_expense_confirmation: 'Are you sure you want to cancel the recurring expense {{name}}?',
    cancel_subscription: 'Cancel Recurring Expense',
    create_recurring_expense: 'Create Recurring Expense',
    edit_recurring_expense: 'Edit Recurring Expense',
    recurring_expense_business: 'Business',
    recurring_expense_details: 'Recurring Expense Details',
    recurring_expense_details_description: 'Configure the parameters of this recurring expense.',
    billing_and_cost: 'Billing & Cost',
    attribution_and_schedule: 'Attribution & Schedule',
    subtotal: 'Subtotal',
    suite: 'Suite',
    summary: 'Summary',
    summary_and_send: 'Summary and Shipping',
    swimming_pool: 'Pool',
    synced_inventory_items: 'Synchronized Inventory Items',
    table: 'Table',
    tag_category: 'Category',
    tag_id: 'Category ID',
    tag_name: 'Category Name',
    tag_source: 'Category Source',
    tag_value: 'Category Value',
    tags: 'Categories',
    takeoff: 'Takeoff',
    target_currency: 'Target Currency',
    target_price: 'Target Price',
    target_email_message_id: 'Target Email Message-ID',
    target_email_message_id_placeholder: 'e.g. <CAH=vXh7z6Vp3P9@mail.gmail.com>',
    tariff_exclusivity_notice: 'These special rates are exclusively available for this client',
    tariff_provider: 'Tariff Provider',
    tariffs: 'Tariffs',
    tariffs_email: 'Email for tariff',
    tariffs_from: 'Rate of',
    task: 'Ticket',
    task_delete: 'Delete Task',
    task_delete_confirmation: 'Are you sure to delete the Task?',
    task_delete_confirmation_cancel: 'Cancel',
    task_delete_confirmation_confirm: 'Delete',
    task_delete_confirmation_description: 'This action cannot be undone',
    task_delete_error: 'Error deleting Task',
    task_deleted: 'Task deleted successfully',
    task_edit: 'Edit Task',
    task_show: 'View Task',
    tasks: 'Tickets',
    tax_name: 'Registered Name',
    tax_condition: 'Tax Condition',
    tax_id: 'CUIL-CUIT',
    tax_id_number: 'Tax ID',
    tax_id_type: 'Tax ID Type',
    template: 'Template',
    template_content: 'Template content',
    template_name: 'Template Name',
    template_name_placeholder: 'Enter a name for the template',
    templates: 'Templates',
    tenant_name: 'Company Name',
    text: 'Text',
    theme_colors: 'Colors',
    they_paid_us: 'They Paid Us',
    this_action_cannot_be_undone: 'This action is permanent',
    this_cost_applies_to_all_providers: 'This cost will apply to all providers',
    this_discount_will_be_applied_to: 'This discount will be applied to',
    this_is_a_payment: 'This is a Payment',
    this_is_a_refund: 'This is a Refund',
    this_price_applies_to_all_providers: 'This price will apply to all suppliers',
    this_price_applies_to_selected_provider_only: 'This price will apply to a specific provider',
    this_week_reservation: 'This week\'s reservations',
    this_weeks_reservations: 'This Week\'s Reservations',
    threshold: 'Limit',
    thread_settings_title: 'Conversation Threading (Optional)',
    ticket: 'Ticket',
    ticket_content_placeholder: 'Add description...',
    ticket_number: 'Ticket Number',
    ticket_title_placeholder: 'Ticket title',
    ticketed: 'Billed',
    tickets: 'Tickets',
    time: 'Time',
    time_end: 'Time End',
    time_range: 'Schedules',
    time_start: 'Time Start',
    timeline: 'Itinerary',
    title: 'Title',
    to: 'To',
    to_businesses: 'To companies',
    to_currency: 'Destiny Currency',
    today: 'Today',
    today_service_orders: 'Today\'s service orders',
    todays_bookings: 'Today\'s Bookings',
    todays_reservations: 'Today\'s reservations',
    todays_vehicle_schedule: 'Today\'s Vehicle Agenda',
    todays_vehicles: 'Today\'s Vehicles',
    tomorrow: 'tomorrow',
    tomorrow_service_orders: 'Tomorrow\'s service orders',
    total: 'Total',
    total_after_exchange: 'Total after exchange',
    total_before_exchange: 'Total before exchange',
    total_cost: 'Total Cost',
    total_cost_paid: 'Costs Paid',
    total_costs: 'Costs',
    total_costs_paid: 'Costs Paid',
    total_income: 'Total Income',
    total_income_received: 'Income Received',
    total_my_businesses: 'Total Businesses',
    total_passengers: 'Total Passengers',
    total_pax: 'Total Paxs',
    total_paxs: 'Total Paxs',
    total_price: 'Total Price',
    total_recipients: 'Total Recipients',
    total_refunded: 'Total Refunded',
    total_sells: 'Sales',
    total_sells_paid: 'Paid Sales',
    total_ticketed: 'Total Invoiced',
    total_unpaid_sells: 'Sales receivable',
    tour: 'Tour',
    tour_path: 'Tour path',
    tour_plural: 'Tours',
    tour_type: 'Tour Type',
    tours: 'Tours',
    tours_available: 'Tours available',
    train: 'Train',
    transaction_amount: 'Transaction Amount',
    transaction_amount_exceeds_selected: 'Transaction amount exceeds selected items total',
    transaction_amount_less_than_selected: 'Transaction amount is less than selected items total',
    transaction_from: 'From',
    transaction_id: 'Transaction ID',
    transaction_to: 'To',
    transfer: 'Transfer',
    transfer_placeholder: 'VIP, Exclusive, etc.',
    transfer_plural: 'Transfers',
    transfers: 'Transfers',
    transfers_available: 'Transfers available',
    travel_stop: 'Stop',
    trip: 'Trip',
    trip_reservations: 'Travel Reservations',
    trips: 'Travel',
    type: 'type',
    unassigned: 'Unassigned',
    unassigned_bookings: 'Bookings Without Assigned Date',
    unassigned_services: 'Unassigned Services',
    unavailable: 'Unavailable',
    undated: 'No Date Assigned',
    undated_bookings: 'Reservations without date',
    undated_services: 'Undated services',
    unlimited: 'Unlimited',
    unlink_payment: 'Unlink Payment',
    unlink_service_order: 'Unlink Service Order',
    unlinked_only: 'Unassigned',
    unnamed_client: 'Unnamed Client',
    unpaid: 'Unpaid',
    unpaid_reservations: 'Unpaid Bookings',
    unpaid_provider_costs: 'Pending Provider Costs',
    no_unpaid_provider_costs_found: 'No pending costs found for this provider',
    cost_payment_status: 'Cost Payment Status',
    linked_provider_costs: 'Linked Provider Costs',
    link_provider_cost: 'Link Provider Cost',
    no_linked_provider_costs: 'No linked provider costs',
    booking_already_linked: 'Service booking cost is already linked to this payment',
    linked_items: 'Linked',
    pending_costs: 'Pending Costs',
    paid_costs: 'Paid Costs',
    client_payment_status: 'Client Payment',
    provider_cost_status: 'Provider Cost Payment',
    client_payment: 'Client Payment',
    provider_payment: 'Provider Payment',
    no_client_payments: 'No client payments',
    no_provider_payments: 'No provider payments',
    pay_providers: 'Pay Providers',
    pay_provider: 'Pay Provider',
    select_provider_to_pay: 'Select the provider to register the payment',
    no_pending_provider_costs: 'No pending provider costs',
    unpublished_prices: 'Unpublished Prices',
    unsaved_changes: 'Unsaved changes',
    unscheduled_services: 'Unscheduled Services',
    unselect: 'Deselect',
    unselect_all: 'Unselect all',
    upcoming_reservations: 'Upcoming Reservations',
    update_current_template: 'Update current template',
    update_cost_manually: 'Update Cost Manually',
    update_price_manually: 'Update Price Manually',
    update_progress: 'Update Progress',
    update_single_attribute: 'Update an Attribute',
    update_start_time: 'Update Departure Time',
    updated_at: 'Updated at',
    updated_by: 'Updated by',
    last_updated: 'Last updated',
    updating: 'Updating',
    upload: 'Upload',
    upload_image: 'Upload Image',
    urgent: 'Urgent',
    use_booking_date: 'Service Booking Date',
    use_magic_link: 'Send magic link instead',
    use_password_login: 'Sign in with password instead',
    use_provider_price: 'Use Supplier Price',
    use_reservation_date: 'Reservation Date',
    user: 'User',
    user_roles: {
        external: 'External',
        internal: 'Internal'
    },
    users: 'Users',
    active_user: 'Active User',
    email_has_associated_user: 'This email has an associated user account and cannot be modified or deleted.',
    email_associated_with_user_account: 'This email is associated with an account for {{name}}',
    this_email_is_used_to_login: 'This email is used to log in',
    no_emails_configured_for_this_business: 'No emails configured for this business. Click the + button above to add one.',
    users_settings_desc: 'Manage users, roles, and permissions in your workspace.',
    users_with_access: 'Users with Access',
    using_manual_rate: 'Using manual rate.',
    valid_from: 'Valid From',
    valid_until: 'Valid Until',
    validation: {
        emailInvalid: 'Invalid email',
        emailRequired: 'Email is required'
    },
    van: 'They go',
    van_rental: 'Van Rental',
    van_rental_plural: 'Vans Rentals',
    vehicle: 'Vehicle',
    vehicle_booking: 'Vehicle Reservation',
    vehicle_cost: 'Vehicle Cost',
    vehicle_details: 'Vehicle Details',
    vehicle_information: 'Vehicle Information',
    vehicle_not_found: 'Vehicle not found',
    vehicle_not_selected: 'Vehicle not selected',
    vehicle_type: 'Vehicle Type',
    vehicles: 'Vehicles',
    vendor: 'Vendor',
    vendors: 'Vendors',
    view_all: 'View All',
    view_customer_portal: 'See Customer Portal',
    view_details: 'See Details',
    view_order: 'See Order',
    view_payment: 'See Payment',
    view_public_tariffs: 'See Public Rate',
    view_ticket: 'View Ticket',
    viewer: 'Reader',
    villa: 'Villa',
    wallet_transfer: 'Digital Wallet',
    we_paid_them: 'We Paid Them',
    welcome: 'Welcome',
    last_checked: 'Last checked',
    just_now: 'Just now',
    ago: 'ago',
    what_are_you_looking_for: 'What are you looking for?',
    when: 'When',
    when_question: 'When?',
    where: 'Where',
    who: 'Who',
    who_owns_this_inventory_item: 'Select Company',
    who_question: 'Who?',
    wifi: 'Wi-Fi',
    with_and_without_dates: 'With and Without Dates',
    with_dates: 'Only with dates',
    with_services: 'With Services',
    with_vehicles: 'With vehicles',
    without_dates: 'Only Without Dates',
    without_service_order: 'Without Service Order',
    without_services: 'Without Services',
    workspace_name: 'Name of the Working Group',
    yes: 'Yes',
    yes_save_to_linked: 'Yes, save to connected service',
    yoga: 'Yoga',
    yoga_class: 'Yoga class',
    yoga_class_plural: 'Yoga classes',
    yoga_plural: 'Yogas',
    your_company: 'Your company',
    zero_assigned: '0 assigned',
    service_discounts_desc: 'Only these discounts are explicitly saved and applied to this service.',
    apply_all_defaults: 'Apply All Tenant Defaults',
    no_discounts_configured: 'No custom discounts configured for this service yet. Defaulting to 0% discount.',
    available_tenant_categories: 'Available Tenant Categories',
    available_tenant_categories_desc: 'These categories exist globally in Settings but are NOT active for this service.',
    all_categories_assigned: 'All tenant categories are configured for this service.',
    default_percentages: 'Default Percentages',
    row_display_options: 'Row Display Options',
    attributes_to_show: 'Attributes to display',
    show_pax_phone: 'Show Phone',
    show_pax_email: 'Show Email',
    show_provider: 'Provider',
    show_coordinator: 'Coordinator',
    please_select_date_range: 'Please select a date range to load bookings.',
    please_select_end_date: 'Please select an end date.',
    select_active_starts_or_ends: 'Select an active date or date range to inspect bookings.',
    no_service_bookings_found: 'No service bookings match the selected filters.',
    group_by_category: 'Group by Category',
    ungrouped: 'Ungrouped',
    compress_identical: 'Compress identical',
    uncompress_identical: 'Uncompress identical',
    identical_services_group: 'Identical services',
    identical_bookings_count: '{{count}} bookings',
    unit_price: 'each',
    expand: 'Expand',
    hide_package_parents: 'Hide Package Parents',
    slim_layout: 'Slim Layout',
    estimated_revenue: 'Estimated Revenue',
    total_bookings: 'Total Bookings',
    search_placeholder: 'Search by passenger, client, booking ID, service name...',
    search_and_filters: 'Search & Filters',
    requires_at_least_one_active: 'Requires at least one date range selection',
    show_service_title: 'Service Title',
    show_service_order: 'Service Order',
    show_reservation: 'Reservation',
    show_client_name: 'Client Name',
    show_paxs: 'Passengers',
    show_pax_name: 'Passenger Names',
    show_hour: 'Time',
    show_price: 'Price',
    ascending: 'Ascending',
    descending: 'Descending',
    sort_up: 'Up',
    sort_down: 'Down',
    ids: 'IDs',
    group_by_reservation: 'Group by Reservation',
    grouping: 'Grouping',
    show_booking_id: 'Booking ID',
    show_payment_status: 'Payment Status',
    search_by_reservation_dates: 'Search by Reservation Dates',
    search_by_booking_dates: 'Search by Booking Dates',
    general_service_info: 'Service & General',
    reservation_client: 'Reservation & Client',
    finance: 'Finance',
    allow_edit: 'Allow Edit',
    allow_online_reservations: 'Allow Online Reservations',
    group_by_paxs: 'Group by Passengers',
    no_paxs_specified: 'No passengers specified',
    reservation_passengers: 'Reservation / Passengers',
    booking_start_date: "Booking Start Date",
    show_cost: "Show Cost",
    hide_service_title: "Hide Service Title",
    add_to_all_bookings: "Add to all Bookings",
    remove_from_all_bookings: "Remove from all Bookings",
    booking_dates: 'Booking Dates',
    presets_templates: 'Presets & Templates',
    save_preset: 'Save Preset',
    display_settings: 'Display Settings',
    clear_all: 'Clear All',
    visible_columns: 'Visible Columns',
    price_updated: 'Price Updated',
    reset_defaults: 'Reset Defaults',
    print: 'Print',
    reservations_as_client: 'Reservations as Client',
    bookings_as_provider: 'Bookings as Provider',
    no_bookings: 'No registered bookings',
    register_payment: 'Register Payment',
    register_payment_from_client: 'Register Client Payment',
    register_payment_to_provider: 'Register Provider Payment',
    create_payment_reminder: 'Create Payment Reminder',
    add_new_business: 'Add Business',
    add_new_pax: 'Add Passenger',
    add_new_inventory_item: 'Add Inventory Item',
    new_task: 'New Task',
    bookings_matrix: 'Bookings Matrix',
    service_orders_matrix: 'Service Orders Matrix',
    group_by: 'Group by',
    unassigned_pax: 'Unassigned Pax',
    unassigned_client: 'Unassigned Client',
    unassigned_coordinator: 'Unassigned Coordinator',
    unassigned_inventory: 'Unassigned Inventory',
    owes_to: 'owes to',
    settled: 'Settled',
    received: 'Received',
    from_them: 'from them',
    to_them: 'to them',
    no_service_order: 'No Service Order',
    select_option: 'Select option',
    service_id: 'Service',
    service_id_sort: 'ID',
    flight_departure_location: 'Flight: Origin',
    flight_departure_time: 'Flight: Departure Time',
    flight_arrival_location: 'Flight: Destination',
    flight_arrival_time: 'Flight: Arrival Time',
    bus_departure_location: 'Bus: Origin',
    bus_departure_time: 'Bus: Departure Time',
    bus_arrival_location: 'Bus: Destination',
    bus_arrival_time: 'Bus: Arrival Time',
    bus_brand: 'Bus: Company',
    create_select_new_pax: "Create or Select a Pax",
    create_select_new_business: "Create or Select a Business",
    select_category: "Select Category",
    search_permissions: "Search permissions...",
    all_permissions_enabled: "All permissions enabled",
    no_permissions_enabled: "No permissions enabled",
    manage_permissions: "Manage permissions",
    edit_user: 'Edit User',
    confirm_delete_user: 'Are you sure you want to delete this user?',
    user_updated_successfully: 'User updated successfully',
    user_deleted_successfully: 'User deleted successfully',
    email_required: 'Email is required',
    tenant: 'Tenant',
    you: 'You',
    total_users: 'Total Users',
    no_users_found: 'No users found',
    no_users_found_desc: 'Try adjusting your search criteria or add a new user.',
    permission_overview: 'Permission Overview',
    all_businesses_desc: 'Access to all businesses in the system',
    selected_businesses_desc: 'Restricted access to specified businesses only',
    all_reservations_desc: 'User can edit all reservations',
    only_created_reservations_desc: 'User can only edit reservations created by themselves',
    unknown_error: 'Unknown error occurred',
    never_logged_in: 'Never logged in',
    all_menu_permissions: 'All Menu Permissions',
    all_create_permissions: 'All Creation Permissions',
    back_to_users: 'Back to Users',
    leave_blank_password_help: 'Enter a new password to reset it, or leave blank to keep current password.',
    user_not_found: 'User not found',
    user_details: 'User Details',
    account_details: 'Account Details',
    business_and_scope_access: 'Scope & Business Access',
    dashboard_subtitle: 'Quick access to operations and assignments.',
    active_assignments: 'active assignments',
    view_assignments: 'View assignments',
    quick_actions_subtitle: 'Quickly create new reservations, payments, service orders, businesses, or other resources.',
    new_reservation_desc: 'Create a confirmed reservation',
    new_pending_reservation_desc: 'Create a reservation in pending state',
    new_payment_desc: 'Record a client payment or collection',
    new_service_order_desc: 'Create a new service order to organize passengers',
    new_business_desc: 'Register a new provider, corporate client, or agency',
    new_pax_desc: 'Register the data of a recurring passenger',
    new_service_desc: 'Create a new tour, transfer, or catalog activity',
    new_inventory_item_desc: 'Add a vehicle, room, or assignable guide',
    new_task_desc: 'Create a follow-up task on the dashboard',
    this_week: 'This Week',
    magic_link_description: "Enter your email address and we'll send you a secure link to log in instantly.",
    'magic-link-sent-description': 'We sent a magic link to your email. Please check your inbox.',
    send_magic_link: 'Send Magic Link',
    verifying_session: 'Verifying magic link...',
    verifying_session_desc: 'Please wait while we log you in.',
    create_account_link: "Don't have an account? Sign up",
    create_account_description: "Enter your email address to check for a registered business and create your account.",
    back_to_login: "Back to Login",
    user_exists_title: "Account Already Exists",
    user_exists_desc: "An account with this email is already registered. Please log in.",
    no_business_found_title: "Business Not Found",
    no_business_found_desc: "This email is not registered with any Turizi business. Please contact your administrator.",
    try_another_email: "Try Another Email",
    business_found_title: "Business Found",
    business_found_desc: "We found a registered business associated with your email address.",
    are_you_part_of_business: "Are you part of this business?",
    yes_create_account: "Yes, create my account",
    no_go_back: "No, go back",
    account_created_title: "Account Created!",
    not_found: "Not found",
    go_back: "Go back",
    business_not_found: "Business not found",
    reservation_not_found: "Reservation not found",
    activity_overview: "Activity Overview",
    activity_overview_subtitle: "Monitor bookings, passengers, and service orders.",
    balance_dates: "Period",
    all_history: "All History",
    select_dates: "Select Dates",
    decrease_font_size: "Decrease font size",
    increase_font_size: "Increase font size",
    premium_feature_title: "Premium Feature",
    paying_customers_only_heading: "Paying Customers Only",
    paying_customers_only_description: "This feature is only available for paying customers. Please contact us at hola@turizi.com to upgrade your account and unlock all premium features.",
    tax_settings: "Tax Settings",
    tax_settings_desc: "Configure the tax integration for electronic billing in your country.",
    tax_settings_subtitle: "Manage electronic billing and tax integrations.",
    afip_arca_settings: "ARCA / AFIP Settings (Argentina)",
    afip_arca_settings_desc: "Allows automating certificate creation and authorizing the Electronic Invoice Web Service (wsfe).",
    afip_sdk_token: "Afip SDK Access Token",
    cuit: "CUIT",
    arca_username: "ARCA User CUIT (Fiscal Key)",
    arca_password: "ARCA Fiscal Password",
    alias: "Certificate Alias",
    environment: "Environment",
    homologation: "Homologation (Testing)",
    production: "Production",
    generate_certificate: "Generate Certificate",
    authorize_web_service: "Authorize Web Service",
    certificate_generated: "Certificate Generated",
    service_authorized: "Service Authorized (wsfe)",
    save_settings: "Save Settings",
    generating_certificate: "Generating certificate...",
    authorizing_service: "Authorizing service...",
    certificate_generated_success: "Certificate generated successfully",
    service_authorized_success: "Web service authorized successfully",
    error_generating_certificate: "Error generating certificate",
    error_authorizing_service: "Error authorizing web service",
    afip_error_detail: "AFIP Integration Error Detail",
    afip_error_desc: "The server returned the following detailed validation/error data when communicating with the AFIP SDK API:",
    integration_steps_title: "Integration Steps & Status",
    integration_steps_desc: "Follow these steps to complete your electronic billing integration with ARCA/AFIP.",
    step_save_credentials: "1. Save Credentials",
    saved: "Saved",
    pending_config: "Pending Configuration",
    step_save_credentials_desc: "Fill in your environment and ARCA credentials in the form below and click the \"Save Settings\" button at the bottom.",
    step_generate_certificate: "2. Generate Digital Certificate",
    certificate_active: "Certificate Active",
    pending_generation: "Pending Generation",
    step_generate_certificate_desc: "Generates the SSL certificate and private key required to authenticate requests to ARCA.",
    step_authorize_service: "3. Authorize Web Service",
    service_authorized_badge: "Service Authorized (wsfe)",
    pending_authorization: "Pending Authorization",
    step_authorize_service_desc: "Authorizes the Electronic Invoice Web Service (wsfe) using your generated digital certificate.",
    step_create_sales_point: "4. Create Point of Sale",
    step_create_sales_point_desc: "Creates a point of sale directly in ARCA using your credentials.",
    create_sales_point_btn: "Create Point of Sale",
    pos_auto_config_info: "Turizi will automatically scan your existing points of sale in ARCA, identify the next available number, register a dedicated POS (named \"Turizi POS\") for this integration, and keep a record of all other points of sale.",
    auto_configure_sales_point_btn: "Auto-configure Point of Sale",
    other_detected_sales_points: "Other Detected Points of Sale",
    sales_point_number: "Point of Sale Number",
    sales_point_name: "Point of Sale Name",
    sales_point_system: "Billing System",
    sales_point_address: "Registered Address",
    sales_point_address_placeholder: "Select or enter the official address registered in ARCA",
    sales_point_address_hint: "Fiscal address or branch declared in the ARCA Registry System for this CUIT.",
    sales_point_created_success: "Point of Sale created successfully!",
    sales_point_active: "Point of Sale Created",
    pending_sales_point: "Pending POS Creation",
    error_creating_sales_point: "Error creating point of sale",
    add_sales_point: "Add Point of Sale",
    edit_sales_point: "Edit Point of Sale",
    delete_sales_point: "Delete Point of Sale",
    configured_sales_points: "Configured Points of Sale",
    no_sales_points_configured: "No points of sale configured yet.",
    confirm_delete_sales_point: "Are you sure you want to delete this point of sale?",
    sales_points_section_title: "Points of Sale (POS)",
    sales_points_section_desc: "Manage AFIP / ARCA points of sale and configure them for use with Turizi services.",
    afip_previous_sales_points_title: "Points of Sale Loaded from AFIP / ARCA",
    afip_previous_sales_points_desc: "Existing points of sale in AFIP associated with your CUIT. You can import them for use in Turizi.",
    env_production_portal: "ARCA Portal (Production)",
    homologation_pos_notice_title: "Testing Environment (Homologation)",
    homologation_pos_notice_desc: "The sales points listed below are fetched directly from the official ARCA portal (Production). Since you are in Homologation mode, AFIP's test Web Service allows invoice testing with any sales point configured in Turizi.",
    sync_afip_sales_points_btn: "Load / Sync from AFIP",
    sync_afip_sales_points_success: "Points of sale successfully synchronized from AFIP",
    sync_afip_sales_points_error: "Error synchronizing points of sale from AFIP",
    import_to_turizi: "Use in Turizi",
    already_configured_in_turizi: "Configured",
    requires_web_services: "Requires Web Services",
    no_sales_points_configured_hint: "No sales points configured for invoicing in Turizi. Click 'Use in Turizi' on one of your Web Services points loaded above, or use 'Autoconfigure Point of Sale'.",
    create_afip_sales_point_modal_title: "Create Point of Sale in AFIP / ARCA",
    create_afip_sales_point_modal_desc: "Enter the trade name to register a new official point of sale in your AFIP / ARCA account enabled for Web Services.",
    create_in_afip_btn: "Create in AFIP",
    origin_afip: "AFIP (Pre-existing)",
    origin_user: "User Created",
    origin_label: "Origin",
    status_in_afip: "AFIP Status",
    no_afip_points_loaded: "No points of sale loaded from AFIP yet. Click 'Load / Sync from AFIP' to query your existing points in ARCA.",
    view_certificate: "View Certificate",
    copy_certificate: "Copy Certificate",
    certificate_copied_success: "Certificate copied to clipboard",
    certificate_modal_title: "Generated SSL Certificate",
    certificate_modal_desc: "This is the generated SSL certificate for your integration. You can copy it if you need it for manual configuration.",
    generate_invoice: "Generate Electronic Invoice (AFIP)",
    generate_invoice_desc: "Create and authorize electronic invoices directly with ARCA / AFIP using your active digital certificate.",
    receiver_section: "Receiver / Customer",
    select_client_selector: "Select Client (Pax/Business)",
    manual_entry_toggle: "Enter receiver details manually",
    receiver_name: "Receiver Name / Business Name",
    invoice_details_section: "Invoice Details",
    invoice_type: "Invoice Type",
    pos_label: "Point of Sale (Punto de Venta)",
    select_pos_placeholder: "Select Point of Sale",
    pos_required_error: "Please select a Point of Sale",
    concept_label: "Concept",
    invoice_description_label: "Description / Detail",
    invoice_description_placeholder: "E.g. Billing of Services",
    amounts_section: "Amounts",
    tax_net_amount: "Net Amount",
    iva_rate: "IVA Rate",
    iva_amount: "IVA Amount",
    total_amount: "Total Amount",
    generate_button: "Generate Invoice",
    invoice_generated_success: "Invoice generated successfully",
    invoice_number_result: "Invoice Number",
    cae_result: "CAE",
    cae_expiration_result: "CAE Expiration",
    factura_a_requires_cuit: "Factura A requires a CUIT document type.",
    success: "Success",
    invalid_doc_number: "Please enter a valid document number.",
    download: "Download",
    no_vouchers: "No vouchers found",
    afip_vouchers: "AFIP Vouchers",
    receiver: "Receiver",
    delete_payment: "Delete Payment",
    are_you_sure_delete_payment: "Are you sure you want to delete this payment?",
    delete_payment_warning: "Once deleted, this payment record cannot be recovered.",
    it_provider: "IT Provider",
    gas_station: "Gas Station",
    last_payment: "Last Payment",
    next_payment: "Next Payment",
    no_payments_registered: "No payments registered",
    payments_for_recurring_expense_description: "Payments registered specifically for this recurring expense.",
    add_payment_for_this_expense: "Record Payment",
    register_payment_for_recurring_expense: "Record Payment for Recurring Expense",
    debt_percentage: "Debt Percentage",
    coverage: "Coverage",
    total_consumption: "Total Consumption",
    covers: "covers",
    of_total_consumption: "of total consumption",
    reconciliation: "Reconciliation",
    outstanding: "Outstanding",
    outstanding_percentage: "Outstanding %",
    total_billed: "Total Billed",
    of_total_billed: "of total billed",
    past_reservations: "Past Reservations",
    future_reservations: "Future Reservations",
    all_reservations: "All Reservations",
    reconciliation_explainer_title: "Automatic Reconciliation Explainer",
    reconciliation_explainer_desc: "The reconciliation system matches total billed services against actual cash payments to calculate the outstanding balance.",
    reconciliation_formula: "Calculation Formula",
    bookings_found_sales: "We sold {{count}} bookings for a total of {{amount}}",
    bookings_found_purchases: "We purchased {{count}} bookings for a total of {{amount}}",
    payments_found_received: "We received {{count}} payments for a total of {{amount}}",
    payments_found_sent: "We sent {{count}} payouts for a total of {{amount}}",
    reconciliation_details: "Reconciliation Details",
    debits: "Debits (Value delivered / cash paid)",
    credits: "Credits (Value received / cash received)",
    total_debits: "Total Debits",
    total_credits: "Total Credits",
    we_owe_client: "We owe partner",
    client_owes_us: "Partner owes us",
    override_payment_status: "Set to {{status}}",
    payments_sent: "Payouts Sent",
    payments_received: "Payments Received",
    by_period: "by period",
    linked_paxs: "Linked Passengers",
    no_linked_paxs: "No passengers linked to this booking yet",
    please_add_paxs_from_the_reservation: "Add passengers from the reservation on the right",
    all_reservation_paxs_linked: "All reservation passengers are linked",
    add_passengers: "Add Passengers",
    from_reservation: "From Reservation",
    send_settlement_by_email: "Send settlement by email",
    send_settlement: "Send Settlement",
    sending_history: "Email Sending History",
    loading_history: "Loading history...",
    no_sending_history: "No email sending history found.",
    reservation_issues: "Reservation Issues",
    we_detected_reservation_issues: "We detected {{count}} reservations with incomplete or inconsistent data.",
    no_client_assigned: "No client assigned (Person or Business)",
    no_start_date: "Missing start date",
    issues: "Issues",
    financial_issues: "Financial Issues",
    pax_issues: "Passenger Issues",
    business_issues: "Business Issues",
    duplicate_businesses: "Duplicate Businesses",
    no_duplicate_businesses_found: "No duplicate businesses found.",
    pax_business_issues: "Pax/Business Issues",
    no_pax_business_issues_found: "No pax/business name conflicts found.",
    service_issues: "Service Issues",
    services_without_providers: "Services with cost but no suppliers",
    service_has_costs_no_providers: "This service has sell costs configured but no supplier assigned.",
    duplicate_pax_desc: "Passenger records sharing the exact same name.",
    missing_lastname_desc: "Passenger is missing a last name (single word name).",
    duplicate_business_desc: "Business records with duplicate names or business titles.",
    pax_business_conflict_desc: "Name conflict: Both passengers and businesses exist with the exact same name.",
    reservation_issues_desc: "Reservations with incomplete data or billing discrepancies.",
    service_issues_desc: "Active services with costs but no suppliers configured.",
    validation_costs_without_providers: "The service has configured costs but no supplier assigned.",
    validation_no_price_by_nor_cost_by: "The service has neither a pricing unit (price_by) nor a cost unit (cost_by) configured.",
    validation_no_active_sell_price: "The service has no active sell price (all configured prices are in the past or missing).",
    validation_booking_no_provider_with_cost: "Service Booking #{{bookingId}}: No supplier selected, but has a cost of {{amount}} {{currency}}.",
    validation_booking_cost_higher_than_sell: "Service Booking #{{bookingId}}: The cost ({{cost}}) is higher than its sell price ({{sellPrice}}).",
    no_service_issues_found: "No service issues found.",
    no_issues_found: "No issues found.",
    login_popup_title: "Client & Partner Area",
    login_popup_text_1: "Log in",
    login_popup_text_2: "to access your special rates, view your current balance, and manage your reservations.",
    included_in_package: "Included in Package",
    child_booking_price_tooltip: "The price of this service is included in the main package.",
    flights: "Flights",
    scheduled_short: "Sched.",
    projected_short: "Projected",
    actual_short: "Actual",
    period_summary: "Period Summary",
    payments_applied: "Payments Applied",
    total_reservations_amount: "Total Reservations",
    link_reservation: "Link Reservation",
    unlink_reservation: "Unlink Reservation",
    enter_reservation_id: "Enter reservation ID (e.g. 1234)...",
    reservation_already_linked: "Reservation is already linked",
    period_balance_email_desc: 'A detailed summary of reservations and payments for the selected period will be sent.',
    all_balance_email_desc: 'A consolidated account statement with the total balance up to date will be sent.',
    document_number: "Document No.",
    delete_link: "Delete link",
    edit_applied_amount: "Edit applied amount",
    amount_must_be_greater_than_zero: "Amount must be greater than 0",
    no_attachments: "No attachments uploaded",
    add_notes: "Add notes...",
    external_code: "External Code",
    add_external_code: "External Code",
    external_code_placeholder: "Enter external code...",
    product: "Product",
    add_product: "Add Product",
    create_product: "Create Product",
    edit_product: "Edit Product",
    product_name: "Product Name",
    linked_services: "Linked Services",
    book_linked_services_question: "Also book these linked services?",
    no_linked_services: "No linked services",
    add_linked_service: "Add Linked Service",
    cannot_link_service_to_itself: "Cannot link a service to itself",
    service_linked_successfully: "Service linked successfully",
    service_link_removed: "Linked service removed",
    service_already_linked: "This service is already linked",
    no_products_yet: "No products yet",
    products_description: "Products allow you to group services to visualize and manage them together.",
    no_services_linked: "No services linked",
    product_not_found: "Product not found",
    selected_services_count: "{{count}} service(s) selected",
    assigned_to_other_product: "Assigned to another product",
    no_product: "No Product",
    group_by_product: "Group by Product",
    confirm_delete_product: "Are you sure you want to delete this product?",
    delete_product: "Delete product",
    unlink_service: "Unlink service",
    amount_to_link: "Amount to link",
    add_note: "Add note",
    edit_note: "Edit note",
    no_notes: "No notes added yet",
    no_linked_reservations: "No linked reservations",
    unallocated_balance: "Unallocated balance",
    unassigned_money: "Unassigned money",
    assigned_to_reservations: "Assigned to reservations",
    fully_linked: "Fully linked",
    partially_linked: "Partially linked",
    not_linked: "Not linked",
    fully_allocated: "Fully allocated",
    over_allocated: "Over allocated",
    search_payments_placeholder: "Search by ID, payer, recipient, amount...",
    filter_by_allocation: "Filter by allocation",
    allocation_status: "Allocation",
    total_payments_count: "Total Payments",
    affected_payments: "Affected / Linked Payments",
    unaffected_payments: "Unaffected / Unlinked Payments",
    unaffected_payments_desc: "Payments not affecting any reservation or service order",
    no_unaffected_payments: "All payments are currently affecting items (no unlinked payments)",
    unaffected_payments_list: "Unaffected Payments List",
    auto_assign: "Auto Assign",
    auto_assign_payments: "Auto Assign Payments",
    auto_assign_payments_title: "Automatic Payment Assignment",
    auto_assign_payments_desc: "Automatically assigns unlinked payments to the oldest unpaid reservations or service orders.",
    calculating_auto_assignments: "Analyzing payments and finding matches...",
    auto_assign_no_payments_to_assign: "No payments with possible assignments were found.",
    auto_assign_confirm: "Confirm Assignment",
    auto_assign_confirm_count: "Confirm Assignment ({{count}})",
    payments_auto_assigned_success: "Payments were successfully assigned.",
    payments_auto_assigned_error: "An error occurred while assigning payments.",
    unassigned_reason_zero_amount: "Payment amount is 0",
    unassigned_reason_internal_transfer: "Internal transfer between own accounts",
    unassigned_reason_missing_client: "Payment client was not identified",
    unassigned_reason_missing_provider: "Payment provider was not identified",
    unassigned_reason_unknown_direction: "Could not determine payment direction",
    unassigned_reason_no_matching_unpaid_reservations: "No unpaid reservations in the same currency",
    unassigned_reason_no_matching_unpaid_bookings: "No unpaid service orders in the same currency",
    will_assign: "Will be assigned",
    partial_assignment: "Partial assignment",
    cannot_assign: "Cannot assign",
    remains_unallocated: "remains unallocated",
    assignments_preview: "Assignments Preview",
    total_to_assign: "Total to assign",
    target_item: "Target item",
    balance_before_after: "Pending balance",
    can_assign: "Assignable",
    unassignable: "Unassignable",
    analyzed_payments: "Analyzed payments",
    overpaid_discrepancy_title: "Overpayment / Exceeded Amount Notice",
    overpaid_discrepancy_desc: "Recorded paid amount exceeds total sales value due to reservations with overpayments or extra charges.",
    overpaid_amount: "Exceeded Amount",
    over_allocated_payments: "Over-allocated Payments",
    over_allocated_payments_desc: "Payments whose allocated amount to items exceeds the payment total",
    over_allocated_payments_list: "Over-allocated Payments List",
    allocated_amount: "Allocated Amount",
    business_already_exists: "A business with this name already exists",
    existing_business_matches: "Existing matching businesses",
    no_matching_business_found: "No matching business found",
    type_to_search: "Type at least 3 characters to search",
    deleted_reservations: "Deleted reservations",
    deleted_reservation: "Deleted reservation",
    clean_filters: "Clear Filters",
    round_trip: "Round Trip",
    deleted_by: "Deleted by",
    deleted_at: "Deletion date",
    deleted_reservation_banner: "This reservation was deleted on {{date}} by {{user}}.",
    no_deleted_reservations: "No deleted reservations",
    original_reservation_id: "Original Reservation ID",
    linked_pax: "Linked Pax",
    linked_business: "Linked Business / Client",
    document: "Document",
    document_type: "Document Type",
    send_email_campaign: "Send Email Campaign",
    no_emails_selected: "No emails selected",
    sent_email_history: "Sent Email History",
    deselect_all: "Deselect all",
    detailed_title: "Detailed Title",
    no_emails_configured: "No emails configured for this business",
    select_recipient_emails: "Select Recipient Emails",
    no_emails_sent_yet: "No emails sent yet",
    step_1_pax: "Passengers",
    step_1_pax_dates: "Passengers & Dates",
    step_2_select_service: "Select Service",
    step_3_booking_attrs: "Attributes & Details",
    step_next: "Next",
    step_back: "Back",
    select_a_service: "Select a service",
    no_attrs_required: "No additional attributes required",
    search_service_placeholder: "Search service...",
    no_services_found: "No services found",
    per_person: "per Person",
    back_to_tickets: "Back to Tickets",
    priority: "Priority",
    delete_ticket: "Delete Ticket",
    delete_ticket_desc: "Once deleted, this ticket cannot be recovered.",
    ticket_saved_success: "Ticket saved successfully",
    ticket_updated_success: "Ticket updated successfully",
    opened_on: "opened this ticket on",
    price_modifiers: "Price Modifiers",
    add_price_modifier: "Add Price Modifier",
    remove_price_modifier: "Remove Price Modifier",
    price_modifier_section: "Section",
    price_modifier_type: "Modifier Type",
    price_modifier_value: "Value / Amount",
    price_modifier_description: "Description",
    price_modifier_currency: "Currency",
    fixed_amount: "Fixed Amount",
    taxes: "Taxes",
    manual_adjustment: "Manual Discount",
    voucher: "Voucher / Coupon",
    surcharge: "Surcharge",
    fee: "Fee",
    add_modifier: "Add Modifier",
    confirm_delete_price_modifier: "Are you sure you want to delete this price modifier?",
    price_modifier_added: "Price modifier added successfully",
    price_modifier_deleted: "Price modifier deleted",
    no_price_modifiers: "No price modifiers",
    all_currencies: "All currencies",
    modifier_operation: "Operation",
    price_modifier_placeholder: "e.g. VAT 21%, Early Bird Discount",
    service_bookings_subtotal: "Services Subtotal",
    itemized_bookings: "Itemized Services",
    original_amount: "Original Amount",
    modify_price: "Modify Price",
    modify_prices: "Modify Prices",
    multiply_current_price_by_factor: "Multiply current price by this factor",
    services_with_modified_prices: "Services with Modified Prices",
    no_active_price_found: "No active price found",
    no_services_with_active_price: "None of the selected services has an active price",
    current_price: "Current price",
    modified_price: "Modified price",
    keep_current_date: "Keep current date",
    price_amount_currency: "Price Amount / Currency",
    price_start_day: "Price Start Date",
    price_end_day: "Price End Date",
    date_asc: "Date Ascending",
    date_desc: "Date Descending",
    infant: "Infant",
    child: "Child",
    senior: "Senior",
    filter_target: "Filter Date By",
    filter_target_all: "Reservation or Booking",
    filter_target_reservation: "Reservation Start",
    filter_target_booking: "Booking Start",
    date_filter_mode: "Date Mode",
    single_day: "Single Day",
    clear_date_filter: "All Dates",
    status_all: "All Statuses",
    role_filter: "Role",
    all_roles: "All Roles",
    total_reservations: "Reservations",
    collapsed_summary_bookings: "bookings",
    collapsed_summary_pax: "passengers",
    google_account_connected: "Google account connected successfully",
    google_account_connection_failed: "Failed to connect Google account",
    google_account_disconnected: "Google account disconnected",
    email_thread_linked_successfully: "Email thread linked to reservation successfully",
    failed_to_link_email_thread: "Failed to link email thread to reservation",
    email_thread_unlinked_successfully: "Email thread unlinked from reservation",
    email_reply_sent_successfully: "Reply sent successfully",
    failed_to_send_reply: "Failed to send reply",
    connecting_google_account: "Connecting to Google...",
    please_wait_while_connecting: "Please wait while authentication completes.",
    link_email_to_reservation: "Link Email to Reservation",
    suggested_searches: "Suggested Searches",
    search_gmail_inbox_placeholder: "Search Gmail inbox by subject, sender, or text...",
    searching_emails: "Searching emails...",
    no_subject: "(No Subject)",
    no_emails_found_matching_query: "No emails found matching your query.",
    enter_search_to_find_emails: "Enter a search term to find emails in your inbox.",
    email_thread: "Email Thread",
    messages: "messages",
    loading_thread: "Loading messages...",
    write_reply_placeholder: "Write your reply here...",
    send_reply: "Send Reply",
    reply: "Reply",
    reply_all: "Reply All",
    no_messages_in_thread: "No messages in this email thread.",
    show_quoted_text: "Show quoted text",
    hide_quoted_text: "Hide quoted text",
    quoted_text: "Quoted text",
    emails_and_messages: "Emails & Messages",
    disconnect_google_account: "Disconnect Google Account",
    link_email: "Link Email",
    new_email: "New Email",
    connect_gmail: "Connect Gmail",
    connect_gmail_account_title: "Connect your Gmail account",
    connect_gmail_account_description: "Link email threads, read full conversations, and reply directly inside this reservation without leaving the app.",
    connect_now: "Connect Now",
    open_and_reply: "View & Reply",
    unlink: "Unlink",
    no_linked_emails_yet: "No emails linked to this reservation yet. Click 'Link Email' or 'New Email' to get started.",
    google_auth_success_hint: "Your account has been successfully connected. You can now close this window to return to the reservation.",
    google_auth_failed_hint: "An error occurred while authorizing your Google account. Please close this window and try again.",
    invalid_auth_code: "Invalid or expired authentication code.",
    error_loading_thread_messages: "Could not load messages for this thread",
    google_session_expired_or_invalid_desc: "The Google account session may have expired or is disconnected. Please reconnect your account in Gmail settings.",
    reconnect_google_account: "Reconnect Google Account",
    recipient_email_required: "No valid recipient found to send the reply.",
    cannot_reply_thread_error: "Cannot reply due to an error loading the conversation.",
    close_window: "Close window",
    gmail_link: "Gmail Link",
    gmail_link_desc: "Connect one or more Gmail accounts for your organization to link emails with reservations and reply to messages.",
    connected_gmail_accounts: "Connected Gmail Accounts",
    gmail_accounts_section_desc: "Gmail accounts authorized to link and interact with customer and vendor emails.",
    no_gmail_accounts_connected: "No Gmail accounts connected",
    connect_gmail_account: "Connect Gmail Account",
    connect_gmail_account_help: "Connecting a Gmail account allows your team to link email threads and reply directly inside reservations.",
    connect_another_gmail_account: "Connect another Gmail account",
    status_expired: "Expired",
    status_insufficient_permissions: "Insufficient permissions",
    google_insufficient_scopes: "Insufficient Gmail permissions. Reconnect your account and grant Gmail access.",
    reconnect: "Reconnect",
    disconnect_gmail_account_confirm: "Are you sure you want to disconnect {{email}}? Previously linked emails will not be removed.",
    linked_emails: "Linked emails",
    linked_emails_count: "{{count}} linked email",
    linked_emails_count_plural: "{{count}} linked emails",
    open_in_gmail: "Open in Gmail",
    recipient_to: "To",
    name_optional: "Name (Optional)",
    all_clients: "All clients",
    client_business: "Client business",
    business_specific_price: "Business-specific price",
    this_price_applies_to_all_clients: "This price applies to all clients",
    price_applies_to_business: "Exclusive price for {{name}}",
    business_contract_price: "Contracted business price",
    default: "Standard",
    upcoming: "Upcoming",
    no_prices_configured: "No prices configured for this service yet.",
    no_prices_description: "Add seasonal or provider-specific rates to manage how this service is priced.",
    no_costs_configured: "No costs configured for this service yet.",
    no_costs_description: "Add provider purchase costs to calculate profit margins and vendor balances.",
    no_rates_defined: "No rates defined",
    registered_payments: "Registered payments",
    without_scheduled_date: "Without scheduled date",
    comments: "Comments",
    no_tickets: "No tickets found",
    chat_title: "Chat",
    chat_suggested: "Suggested",
    chat_new_chat: "New chat",
    chat_welcome_title: "How can I help you today?",
    chat_welcome_subtitle: "Ask about tours, excursions, activities, and prices.",
    chat_input_placeholder: "Type a message...",
    chat_send: "Send",
    chat_services_title: "Services",
    chat_services_empty: "No services referenced yet.",
    chat_view_service: "View",
    chat_typing: "Typing...",
    chat_hide_services: "Hide services",
    chat_show_services: "Services",
    chat_rate_on_request: "Rate on request",
    chat_cart_title: "Pinned Services",
    chat_pin_service: "Pin",
    chat_pinned_service: "Pinned",
    chat_add_to_cart: "+ Pin",
    chat_in_cart: "Pinned",
    chat_remove_from_cart: "Remove",
    chat_clear_cart: "Clear",
    chat_checkout: "Book now",
    chat_cart_total: "Estimated total",
    chat_cart_empty: "No services pinned yet. Pin services from the chat to build your package.",
    chat_ask_about_pinned: "Inquire about these services",
    chat_ask_about_pinned_prompt: "I would like to inquire about and compare these services in my budget: {names}",
    copy_budget: "Copy Quote",
    chat_history_title: "Conversation History",
    chat_history_subtitle: "Resume or review previous conversations with the assistant.",
    chat_history_empty: "No previous conversations saved.",
    chat_history_empty_hint: "When you start a conversation, it will be saved here so you can continue anytime.",
    chat_history_open: "Continue conversation",
    chat_history_messages: "messages",
    chat_history_new_chat: "Start new conversation",
    chat_history_delete: "Delete",
    chat_history_active: "Active",
    tax_percentage: "Tax Percentage",
    tax_percentage_desc: "Tax rate for generating tax receipts for this service",
    pos_desc: "Point of Sale assigned to this service for invoicing",
    tax_invoicing_settings: "Tax & Invoicing Settings",
    generate_tax_receipts: "Generate AFIP Tax Receipts",
    generate_tax_receipts_desc: "Automatic grouping by Point of Sale (POS) and tax percentage of reservation services",
    grouped_receipts_to_generate: "Grouped receipts to generate",
    no_billable_services: "There are no services with a billable amount greater than 0 in this reservation.",
    generate_all_receipts: "Generate all receipts",
    generate_receipt: "Generate receipt",
    receipt_generated: "Receipt generated",
    afip_not_configured_alert: "AFIP is not configured on this account. Please upload certificates and fiscal data in settings.",
    download_pdf: "Download PDF",
    select_tax_percentage: "Select tax percentage",
    group_summary: "Group summary",
    update_reservation_tax_id: "Save receipt numbers in reservation",
    receipts_generated_successfully: "Receipts generated successfully",
    send_by_email: 'Send by Email',
    send_voucher_by_email: 'Send Voucher by Email',
    destination_email: 'Destination Email',
    voucher_email_sent_successfully: 'Voucher sent successfully by email',
    failed_to_send_voucher_email: 'Failed to send voucher by email',
    failed_to_download_pdf: 'Failed to download PDF',
    taxed_amount: 'Taxed Amount',
    total_vouchers: 'Vouchers',
    search_afip_vouchers: 'Search by client, document, number, reservation or CAE...',
    tax_settings_bulk_desc: 'Bulk update Point of Sale (POS) and Tax Percentage settings for the selected services.',
    modify_pos: 'Modify Point of Sale (POS)',
    modify_tax_percentage: 'Modify Tax Percentage',
    filter_by_client: 'Filter by client',
    filter_by_currency: 'Filter by currency',
    total_invoiced: 'Total Invoiced',
    date_type: 'Date Type',
    registration_date: 'Registration Date',
    registered: 'Registered',
    no_payment_date: 'No payment date',
    due: 'Due',
    total_sold: 'Total Sold',
    difference: 'Difference',
    sold_vs_invoiced: 'Sold vs Invoiced',
    pending_to_invoice: 'Pending to invoice',
    business_emails: 'Business emails',
    pax_groups: 'Passenger Groups',
    pax_group: 'Passenger Group',
    not_assigned_to_services: 'Not assigned to any service',
    add_pax_group: 'Add Group',
    edit_pax_group: 'Edit Group',
    edit_pax: 'Edit Passenger',
    single_pax: 'Single Passenger',
    pax_group_mode: 'Group / Contingent',
    passenger_name: 'Passenger Name',
    passenger_name_placeholder: 'e.g. John Doe',
    or_select_existing_person: 'Or select existing passenger',
    select_existing: 'Search existing',
    delete_pax_group: 'Delete Group',
    delete_pax_group_confirm: 'Are you sure you want to delete this passenger group?',
    pax_group_name: 'Group Name',
    pax_group_name_placeholder: 'e.g. Blue Sky Group, High School Trip...',
    coordinator_business: 'Coordinator / In Charge',
    contact_name: 'Contact Name',
    contact_phone: 'Contact Phone',
    contact_phone_placeholder: 'e.g. +1 555 123-4567',
    pax_group_added_to_all_bookings: 'Group assigned to all services',
    pax_group_removed_from_all_bookings: 'Group unassigned from all services',
    pax_group_created_successfully: 'Passenger group created successfully',
    pax_group_updated_successfully: 'Passenger group updated successfully',
    pax_group_deleted_successfully: 'Passenger group deleted successfully',
    pax_group_create_failed: 'Failed to create passenger group',
    pax_group_update_failed: 'Failed to update passenger group',
    pax_group_delete_failed: 'Failed to delete passenger group',
    no_pax_groups: 'No passenger groups created',
    no_pax_groups_desc: 'Create groups or contingents to organize passengers in this reservation.',
    assign_pax_group: 'Assign Group',
    assign_to_service: 'Assign to this service',
    remove_from_service: 'Remove from service',
    allocated_to_order: 'Allocated to order',
    pax_group_members: 'Group Members',
    pax_group_allocation_per_order: 'Group Allocation per Vehicle',
    total_group_paxs: 'Total in group',
    allocated_in_other_orders: 'Allocated in other orders',
    remaining_to_allocate: 'Remaining to allocate',
    booking_allocation_updated: 'Allocation updated successfully',
    booking_allocation_update_failed: 'Failed to update allocation',
    booking_removed_from_order_successfully: 'Booking removed from order successfully',
    booking_removed_from_order_failed: 'Failed to remove booking from order',
    manage_pax_groups: 'Manage Groups',
    pax_group_empty_warning: 'The group has no passengers defined',
    search_coordinator: 'Search coordinator...',
    no_coordinator_selected: 'No coordinator assigned',
    all_paxs_in_groups: 'Passengers in groups',
    paxs_count_summary: '{{count}} PAX',
    paxs_in_orders_allocated: '{{allocated}} of {{total}} allocated',
    override_group_for_booking: 'Customize count for this service',
    reset_to_default_count: 'Reset to group defaults',
    no_passengers_allocated: 'No passengers allocated',
    no_passengers_associated: 'No passengers associated',
    add_paxs: 'Add Passengers',
    edit_paxs: 'Edit Passengers',
    add_passenger: 'Add Passenger',
    type_name_press_enter: 'Type name and press Enter...',
    group_name_desc: 'Group name (defaults to 1st passenger)',
    group_passengers: 'Group Passengers',
    pax_numbers_breakdown: 'Passenger Breakdown',
    assign_to_bookings: 'Assign to Bookings',
    services_linked_count: '{{linked}} of {{total}} services assigned',
    confirm_modify_booking_with_service_order: 'This booking is already assigned to a service order. Do you want to continue and update the service order as well?',
    phone_2: 'Phone 2',
    add_second_phone: 'Add second phone',
    chat_on_whatsapp: 'Chat on WhatsApp',
    assign_all_group: 'Assign whole group',
    unassign_group: 'Remove from vehicle',
    fully_assigned: 'Fully assigned',
    partially_assigned: 'Partially assigned',
    not_assigned_to_vehicle: 'Not assigned to this vehicle',
    assigned_pax_groups_to_order: 'Group Allocation to Vehicle',
    edit_group_allocation_desc: 'Specify how many passengers from each group travel in this service order.',
    legacy_allocation_desc: 'Adjust the number of passengers allocated to this vehicle.',
    assign_all_groups: 'Assign all groups',
    unassign_all_groups: 'Remove all from vehicle',
    search_group_placeholder: 'Search group or passenger...',
    allocated: 'Allocated',
    allocations: 'Allocations',
    pax_group_mode_headcount: 'By Headcount / Size',
    pax_group_mode_persons: 'Passenger List',
    pax_group_headcount_desc: 'Define the group by specifying the number of passengers per category. Individual names are not required.',
    pax_group_persons_desc: 'Add members to this group. You can search existing passengers or type a name to add them quickly.',
    pax_group_name_hint: 'Identifies this group in the reservation (e.g. family, friends, tour). Can be auto-filled with the first passenger.',
    add_passenger_to_group: 'Add to group',
    passenger_name_input_placeholder: 'Passenger full name...',
    document_optional: 'ID / Document',
    phone_optional: 'Phone',
    no_passengers_in_group_yet: 'No passengers added to this group yet',
    type_name_to_add_passenger: 'Type a name above and press Enter to start building the group.',
    select_and_add: 'Select',
    create_and_add: 'Create and add',
    reservation_persons_suggestions: 'Suggestions from this reservation',
    group_leader: 'Lead',
    adjust_headcount_manually: 'Adjust counts manually',
    hide_headcount_adjustment: 'Hide manual adjustment',
    total_headcount: 'Total Passengers',
    named_passengers_count: '{{count}} named passengers',
    save_group: 'Save Group',
    press_enter_to_add: 'Press Enter to add',
    or_add_as_new: 'or add as new',
    lead_passenger: 'Lead passenger',
    pax_category: 'Category',
    adult: 'Adult',
    search_allocations_placeholder: 'Search by reservation, service, group or passenger...',
    save_booking_allocation: 'Save allocation',
    save_all_changes: 'Save all changes',
    general_pax: 'General',
    select_pax_group: 'Select Passenger Group',
    all_reservation_paxs: 'All reservation passengers',
    customize_group_size: 'Customize counts manually',
    price_generator: 'Price Generator',
    price_generator_desc: 'Calculate and generate sell prices and provider costs from a seed price, tax rate, and differentials.',
    seed_price: 'Seed Price',
    seed_price_desc: 'Base reference amount multiplied by the tax modifier and differentials.',
    tax_modifier: 'Tax Modifier',
    tax_modifier_desc: 'Multiplier derived from VAT (e.g. 21% = 1.2100000000) stored with high precision.',
    diff_category_multipliers: 'Category Differentials',
    differential: 'Differential',
    diff_default: 'General',
    diff_foreigner: 'Foreigner',
    diff_child: 'Child',
    diff_senior: 'Senior',
    diff_retired: 'Retired',
    diff_infant: 'Infant',
    diff_provider: 'Provider',
    rounding_settings: 'Rounding Settings',
    round_to: 'Round to',
    round_method: 'Rounding Method',
    round_nearest: 'Nearest (Round)',
    round_ceil: 'Upwards (Ceil)',
    round_floor: 'Downwards (Floor)',
    cost_multiplier: 'Cost Multiplier',
    cost_multiplier_desc: 'Multiplier factor applied to the seed price to determine provider cost.',
    generate_and_apply_prices: 'Generate and Apply Prices',
    generate_and_apply_desc: 'Creates active records in the sell prices and provider costs tables for this service.',
    save_generator_config: 'Save Configuration',
    generator_config_saved: 'Generator configuration saved successfully',
    apply_to_prices: 'Apply to Prices',
    apply_to_costs: 'Apply to Costs',
    prices_applied_successfully: 'Prices generated and applied successfully',
    costs_applied_successfully: 'Costs generated and applied successfully',
    preview_sell_prices: 'Calculated Sell Prices',
    preview_provider_costs: 'Calculated Provider Costs',
    no_providers_for_costs: 'This service currently has no associated providers. Calculated costs will apply as general cost (all providers).',
    precision_note: 'Modifiers stored with 10 digits of decimal precision (e.g. 1.2100000000).',
    raw_calculation: 'Raw calculation',
    rounded_calculation: 'Final result',
    confirm_generate_prices_title: 'Apply generated prices and costs?',
    confirm_generate_prices_desc: 'This will create a new sell price record and provider cost records effective from the selected date.',
    update_provider_cost_multiplier: 'Update multiplier on provider business',
    start_day: 'Start Date',
    end_day: 'End Date',
    seed_prices_history: 'Seed Prices History',
    no_seed_prices: 'No seed prices recorded',
    use_this_seed_price: 'Use',
    dates_used: 'Dates used',
    pax_discrepancy: 'Passenger Discrepancy',
    pax_discrepancy_count_mismatch: 'The assigned passenger count ({{assigned}}) does not match the booking total ({{booking}}).',
    pax_discrepancy_category_mismatch: 'The passenger category breakdown does not match the booking.',
    pax_discrepancy_assigned: 'Assigned',
    pax_discrepancy_booking: 'Booking',
    prices_and_costs: 'Prices & Costs',
    margins: 'Margins',
    prices_and_costs_description: 'Compare sell prices and provider costs across identical periods to analyze margins and difference.',
    markup: 'Markup',
    net_margin: 'Gross Margin',
    loss: 'Loss',
    unit_profit: 'Profit per Unit',
    no_cost_for_period: 'No cost configured for this period',
    no_price_for_period: 'No price configured for this period',
    no_periods_found: 'No price or cost periods found',
    current_active_period: 'Current Active Period',
    average_margin: 'Average Margin',
    total_periods: 'Total Periods',
    cost_exceeds_price: 'Warning: Cost exceeds sell price!',
    table_view: 'Table',
    cards_view: 'Cards',
    all_tiers: 'All Passenger Tiers',
    passenger_tiers_breakdown: 'Passenger Tiers Breakdown',
    different_currencies_warning: 'Price and cost use different currencies. Difference cannot be computed directly.',
    cost_status_missing: 'Missing Cost',
    price_status_missing: 'Missing Price',
    price_and_cost_comparison: 'Price & Cost Comparison',
    highest_margin: 'Highest Margin',
    lowest_margin: 'Lowest Margin',
    sort_by_margin: 'Margin',
    sort_by_diff: 'Difference',
    days_duration: '{{count}} days',
    days_duration_single: '1 day',
    pax_list: 'Passenger List',
    add_all: 'Add all',
    transport: 'Transport',
    searching: 'Searching',
    search_by_phone: 'Search by Phone',
    search_by_document_number: 'Search by Document',
    search_by_email: 'Search by Email',
    search_or_add_new_passenger: 'Search or Create Pax',
    booking_size: 'Booking Size',
    sync_booking_size_from_groups: 'Sync booking size from groups',
    sync_group_size_from_persons: 'Calculate from selected passengers',
    reset_to_group_defaults: 'Reset to group defaults',
    customized_for_booking: 'Customized',
    select_passengers_for_booking: 'Passengers in this service',
    sell_price: 'Sell Price',
    calculate_costs_from: 'Calculate from',
    pax_profile_title: 'Passenger (Pax) Profile',
    business_as_pax_explanation: 'A Client or Provider can also have a Person (Pax) profile to be assigned as a passenger or staff in reservations.',
    business_profile_title: 'Client / Provider Profile',
    person_as_business_explanation: 'A Person (Pax) can also have a Client or Provider profile to own reservations, manage payments, or provide services.',
    create_as_pax: 'Create as Passenger',
    link_existing_pax: 'Link existing',
    link_or_create_business: 'Link or Create Client/Provider',
    change_linked_pax: 'Change',
    confirm_unlink_pax: 'Unlink the passenger associated with this client/provider?',
    confirm_unlink_business: 'Unlink the client/provider associated with this person?',
    view_pax_profile: 'View passenger profile',
    view_business_profile: 'View client/provider profile',
    delete_price: 'Delete Price',
    delete_cost: 'Delete Cost',
    delete_all_costs: 'Delete all costs from this price',
    expand_all_costs: 'Expand all costs',
    collapse_all_costs: 'Collapse all costs',
    show_costs: 'Show costs',
    hide_costs: 'Hide costs',
    select_sell_price: 'Select sell price',
    create_sell_price_first: 'You must create at least one sell price before adding a cost.',
    show_pax_list: 'Show Passengers',
    only_first_pax: 'Only 1st Passenger',
    retentions: 'Tax Withholdings (Retenciones)',
    add_retention: 'Add Withholding',
    retention_type: 'Withholding Type',
    retention_types: {
        ganancias: 'Income Tax (Ganancias)',
        iibb: 'Gross Income (IIBB)',
        iva: 'VAT (IVA)',
        suss: 'Social Security (SUSS)',
        other: 'Other Withholding'
    },
    retention_jurisdiction: 'Jurisdiction / Province',
    retention_jurisdiction_placeholder: 'e.g. CABA, Buenos Aires, Salta...',
    retention_certificate_number: 'Certificate #',
    retention_certificate_placeholder: 'e.g. 0001-00012345',
    retained_amount: 'Total Withheld',
    net_cash_amount: 'Net Cash / Transfer',
    total_settled_amount: 'Total Settled (incl. withholdings)',
    no_retentions: 'No tax withholdings recorded',
    upload_certificate: 'Upload Certificate',
    provider_tax_vouchers: 'Provider Tax Vouchers',
    add_provider_voucher: 'Add Provider Voucher',
    link_existing_voucher: 'Link Existing Voucher',
    register_new_voucher: 'Register New Voucher',
    emitted_vouchers: 'Issued (Sales)',
    received_vouchers: 'Received (Providers)',
    issuer_provider: 'Issuing Provider',
    issuer_cuit: 'Issuer Tax ID (CUIT)',
    issue_date: 'Issue Date',
    voucher_number_label: 'Voucher Number',
    voucher_type_label: 'Voucher Type',
    cae_optional: 'CAE (Optional)',
    cae_expiration_optional: 'CAE Expiration (Optional)',
    link_to_other_bookings_of_provider: 'Also link to other bookings from this provider',
    no_provider_vouchers: 'No provider tax vouchers linked',
    provider_voucher_created: 'Provider tax voucher registered successfully',
    provider_voucher_linked: 'Voucher linked successfully',
    provider_voucher_unlinked: 'Voucher unlinked',
    select_existing_voucher: 'Select received voucher',
    no_received_vouchers_for_provider: 'No other received vouchers found for this provider',
    upload_voucher_file: 'Attach Voucher PDF / Image',
    retention_percentage: 'Rate (%)',
    retention_preset: 'Standard Rate / Regime',
    select_service_bookings_for_voucher: 'Linked Services in Reservation',
    select_at_least_one_booking: 'Select at least one service booking',
    sync_headcount_to_pax_list: 'Match headcount to passenger list',
    match_count: 'Match to {{count}}',
    bulk_paste_passengers: 'Paste List / Bulk Add',
    single_passenger_mode: 'Single Search',
    bulk_paste_instructions: 'Paste one passenger per line: Name, Document/ID, Phone, Email, Adults, Children, Infants, Seniors, Guests.',
    bulk_paste_placeholder: 'John Doe, 30123456, +5491122334455, john@mail.com, 1, 0, 0, 0, 0\nMary Smith, 28456789, 1144556677\nCharles Lopez, 32987654',
    detected_passengers_preview: 'Detected passengers preview',
    auto_update_adults_count: 'Automatically update adults count',
    import_passengers_count: 'Add {{count}} passengers',
    bulk_passengers_added_count: 'Added {{count}} passengers to the group',
    search_passengers: 'Search passenger...',
    distribute_paxs: 'Distribute Paxs',
    distribute_paxs_across_bookings: 'Distribute in bookings',
    target_bookings_count: '{{count}} bookings selected',
    save_distribution: 'Save Distribution',
    target_services: 'Target Services',
    all_bookings: 'All bookings',
    auto_distribute_by_capacity: 'Auto-distribute by capacity',
    auto_distribute_by_capacity_tooltip: 'Assigns passengers sequentially according to each booking capacity.',
    per_booking: 'per booking',
    match_counts_to_bookings_tooltip: 'Adjusts linked group headcounts to match each booking capacity',
    match_booking_capacities: 'Match capacities',
    click_passenger_to_assign_to_selected_booking: 'Click a passenger to assign or remove them from the selected booking on the right',
    click_passengers_on_left_to_assign_here: 'Click passengers on the left to assign them to this booking',
    no_passengers_assigned: 'No specific passengers assigned',
    pax_distribution_saved: 'Passenger distribution saved successfully',
    show_more_paxs: 'Show {{count}} more passengers',
    show_less: 'Show less',
    csv_no_rows: 'No valid rows found in the CSV.',
    csv_row_missing_name: 'Row {{row}}: Passenger name (first column) is missing.',
    csv_row_invalid_name: 'Row {{row}}: Name "{{value}}" is invalid.',
    csv_row_unclosed_quotes: 'Row {{row}}: Unclosed quotes in CSV format.',
    csv_row_too_many_columns: 'Row {{row}}: Detected {{count}} columns (maximum 9: Name, Document, Phone, Email, Adults, Children, Infants, Seniors, Guests).',
    csv_row_invalid_email: 'Row {{row}}: Email "{{value}}" is not valid.',
    csv_row_invalid_count: 'Row {{row}}: Passenger count "{{value}}" must be an integer.',
    csv_row_duplicate_in_batch: 'Row {{row}}: Duplicate passenger in batch ({{name}} - {{document_number}}), skipped repeated row.',
    csv_row_updated_existing: 'Row {{row}}: Updated existing passenger {{name}}.',
    show_pax_details: 'Show contact details (phone, email)',
    hide_pax_details: 'Hide contact details',
    assigned: 'Assigned',
    matched_passengers: 'Matches',
    matched_passengers_hint: 'Existing passengers will appear as you type',
    found_matching_paxs: 'Found {{count}} paxs with the same name',
    assign_to_booking: 'Assign to booking',
    select_bookings_to_assign: 'Select the bookings to assign this group to'
};







